// import React, { useState, useEffect } from "react";

// const Blog = () => {
//   const [hoveredImage, setHoveredImage] = useState(null);
//   const [isChatOpen, setIsChatOpen] = useState(false);
//   const [chatMessages, setChatMessages] = useState([]);
//   const [chatInput, setChatInput] = useState('');
//   const [leadCaptured, setLeadCaptured] = useState(false);
//   const [awaitingLeadInfo, setAwaitingLeadInfo] = useState(false);
//   const [leadStep, setLeadStep] = useState(0);
//   const [userData, setUserData] = useState({ name: '', phone: '', city: '' });
//   const [messageCount, setMessageCount] = useState(0);
//   const [quickReplies, setQuickReplies] = useState([]);
//   const [chatbotHover, setChatbotHover] = useState(false);

//   useEffect(() => {
//     if (isChatOpen && chatMessages.length === 0) {
//       initChat();
//     }
//   }, [isChatOpen]);

//   const seoData = {
//     title: "Solar Panel Installation Blog Nagpur | Solar Energy Guides & Tips",
//     metaDescription: "Expert solar panel installation guides, cost analysis in Nagpur, Maharashtra solar subsidy information, and renewable energy solutions for residential & commercial properties.",
//     primaryKeyword: "Solar Panel Installation in Nagpur",
//     secondaryKeywords: [
//       "solar company Nagpur",
//       "rooftop solar Nagpur",
//       "solar panel price Nagpur",
//       "Maharashtra solar subsidy",
//       "best solar company Nagpur",
//     ],
//   };

//   const blogContent = [
//     {
//       id: 1,
//       title: "How Solar Panels Work: A Beginner's Guide for Nagpur Homeowners",
//       category: "Educational Guides",
//       date: "Dec 15, 2025",
//       content: "Solar panels convert sunlight into electricity through photovoltaic cells. These cells are made of semiconductor materials, usually silicon, that absorb photons from sunlight and release electrons, generating an electric current. The process involves several key components: solar panels, inverters, and sometimes battery storage systems. This clean, renewable energy source can significantly reduce your carbon footprint and electricity bills, especially for solar panel installation in Nagpur where sunlight is abundant throughout the year. Understanding how solar panels work is the first step towards adopting solar energy solutions in your home or business.",
//       detailedContent: "For residents considering solar panel installation in Nagpur, it's important to know that Nagpur receives approximately 300 sunny days annually, making it ideal for solar energy generation. The photovoltaic cells in solar panels create direct current (DC) electricity, which is then converted to alternating current (AC) by inverters for home use. Modern solar systems in Nagpur typically include monitoring systems that allow homeowners to track energy production in real-time. Whether you're looking at residential solar system Nagpur or commercial solar installation Nagpur, the basic principles remain the same. The efficiency of solar panels has improved significantly, with modern panels converting 20-22% of sunlight into electricity, compared to 15% just a decade ago. For Nagpur homeowners, this means smaller roof space requirements and faster return on investment.",
//       image: "https://images.unsplash.com/photo-1497440001374-f26997328c1b?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
//       readTime: "5 min read",
//       tags: ["Solar Basics", "Technology", "Guide", "Nagpur Solar", "Home Installation"],
//       localKeywords: ["solar panel installation Nagpur", "Nagpur solar company", "home solar Nagpur"],
//       slug: "how-solar-panels-work-nagpur-guide",
//     },
//     {
//       id: 2,
//       title: "Solar Panel Investment ROI in Nagpur 2026: Cost vs Savings Analysis",
//       category: "Cost and Savings Analysis",
//       date: "Dec 10, 2025",
//       content: "With government incentives and falling installation costs, solar panels offer compelling ROI for Nagpur residents. Average payback periods have reduced from 8-10 years to 5-7 years in Maharashtra. Key factors affecting ROI include: your location's sunlight exposure, local electricity rates, available tax credits, and system size. We analyze current market trends showing that residential solar installations continue to offer excellent long-term savings, especially with the Maharashtra solar subsidy program making solar panel installation in Nagpur more affordable than ever.",
//       detailedContent: "For a typical 3kW residential solar system in Nagpur, the installation cost ranges between ₹1.5-2 lakhs after subsidies. This system can generate approximately 12-15 units per day, translating to monthly savings of ₹2,500-3,500 on electricity bills. The Maharashtra government's solar subsidy covers 20-40% of installation costs for residential properties, significantly improving ROI. Commercial solar installation Nagpur offers even better returns due to higher consumption and additional tax benefits. When considering solar panel price in Nagpur, factor in: 1) System size and quality, 2) Installation complexity, 3) Government subsidies available, 4) Financing options from local banks, 5) Maintenance costs (typically 0.5-1% annually). Many Nagpur businesses are switching to solar to combat rising electricity costs from MSEDCL, with rooftop solar Nagpur installations becoming common in industrial areas like Butibori and Hingna.",
//       image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
//       readTime: "7 min read",
//       tags: ["Cost Analysis", "Savings", "Investment", "Nagpur ROI", "Solar Subsidy"],
//       localKeywords: ["solar panel price Nagpur", "solar investment Nagpur", "ROI solar Nagpur"],
//       slug: "solar-panel-investment-roi-nagpur-2026",
//     },
//     {
//       id: 3,
//       title: "Case Study: 500kW Solar-Powered Manufacturing Plant in Nagpur",
//       category: "Customer Stories and Case Studies",
//       date: "Dec 5, 2025",
//       content: "ABC Manufacturing in Hingna, Nagpur reduced their energy costs by 68% after installing our 500kW commercial solar system. The plant now generates 85% of its daytime energy needs through solar power, with an annual saving of ₹42 lakhs. The system included 1,500 solar panels and battery storage for night operations. This transition prevented 850 tons of CO2 emissions annually, showcasing how commercial solar installation Nagpur can transform business operations.",
//       detailedContent: "This Nagpur-based manufacturing unit faced escalating electricity costs of ₹8-10 lakhs monthly. After installing a 500kW on-grid solar system with net metering, their electricity bills reduced to ₹2.5-3 lakhs monthly. The system covers 3 acres of rooftop space and uses high-efficiency bifacial panels that capture light from both sides. Key features of this commercial solar installation Nagpur project: 1) 500kW capacity with 1500 solar panels, 2) 100kW battery backup for critical operations, 3) Smart monitoring system, 4) Remote troubleshooting capability, 5) 25-year performance warranty. The project qualified for both state and central government subsidies, reducing the payback period to 4.5 years. This case demonstrates why Nagpur industries are rapidly adopting solar solutions, with the MIDC offering additional incentives for green energy adoption.",
//       image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
//       readTime: "8 min read",
//       tags: ["Case Study", "Commercial", "Success Story", "Nagpur Industry", "Manufacturing"],
//       localKeywords: ["commercial solar Nagpur", "industrial solar Nagpur", "Nagpur manufacturing solar"],
//       slug: "case-study-solar-manufacturing-plant-nagpur",
//     },
//     {
//       id: 4,
//       title: "Debunking 7 Common Solar Energy Myths for Nagpur Homeowners",
//       category: "Myth Busting",
//       date: "Nov 28, 2025",
//       content: "Myth 1: Solar panels don't work on cloudy days - FALSE. Modern panels work at 10-25% efficiency even on cloudy days. Myth 2: Solar panels damage your roof - FALSE. Proper installation protects your roof. Myth 3: Maintenance is expensive - FALSE. Solar panels require minimal maintenance. Myth 4: They're too expensive - With subsidies in Maharashtra, prices have dropped 70% in 5 years, making solar panel installation in Nagpur highly affordable.",
//       detailedContent: "As a leading solar company in Nagpur, we frequently encounter misconceptions about solar energy. Let's address the most common myths: 1) 'Nagpur doesn't get enough sun' - FALSE: Nagpur receives 6-7 peak sun hours daily, ideal for solar. 2) 'Solar doesn't work during monsoon' - FALSE: German-designed panels work efficiently in diffused light. 3) 'Installation takes months' - FALSE: Most residential solar system Nagpur installations complete in 3-7 days. 4) 'High maintenance needed' - FALSE: Quarterly cleaning and annual inspection suffice. 5) 'Frequent breakdowns' - FALSE: Solar panels have 25-year warranties with <0.5% annual degradation. 6) 'Not suitable for old buildings' - FALSE: Structural assessment ensures safety for all buildings. 7) 'Complicated subsidy process' - FALSE: We handle all Maharashtra solar subsidy paperwork for our Nagpur customers. Understanding these facts helps Nagpur residents make informed decisions about rooftop solar Nagpur installations.",
//       image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
//       readTime: "6 min read",
//       tags: ["Myths", "Facts", "Education", "Nagpur Solar", "Homeowner Guide"],
//       localKeywords: ["solar myths Nagpur", "solar facts Maharashtra", "Nagpur solar truth"],
//       slug: "solar-energy-myths-nagpur-homeowners",
//     },
//     {
//       id: 5,
//       title: "Step-by-Step Solar Subsidy Process in Maharashtra for Nagpur Residents",
//       category: "Step-by-Step Process",
//       date: "Nov 20, 2025",
//       content: "Complete guide to availing solar subsidy in Maharashtra for Nagpur residents. Learn about MSEDCL portal registration, document requirements, inspection process, and subsidy disbursement timeline. Maharashtra offers 20-40% subsidy for residential solar installations through the state solar policy.",
//       detailedContent: "The solar subsidy process in Maharashtra involves: 1) Register on MSEDCL portal, 2) Get technical feasibility approval, 3) Install system from empanelled vendor (like us), 4) Submit commissioning report, 5) Receive subsidy in 30-45 days. For Nagpur residents, additional municipal corporation incentives may apply. The Maharashtra solar subsidy covers: ₹14,000/kW for first 3kW, ₹7,000/kW for next 3kW. We help Nagpur homeowners navigate this process seamlessly.",
//       image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
//       readTime: "6 min read",
//       tags: ["Subsidy Guide", "Maharashtra Solar", "Government Incentives", "Nagpur Process"],
//       localKeywords: ["solar subsidy Maharashtra", "Nagpur solar subsidy", "MSEDCL solar process"],
//       slug: "solar-subsidy-process-maharashtra-nagpur",
//     },
//     {
//       id: 6,
//       title: "On-Grid vs Off-Grid vs Hybrid Solar Systems: Best for Nagpur Homes",
//       category: "Educational Guides",
//       date: "Nov 15, 2025",
//       content: "Choosing between on-grid, off-grid, and hybrid solar systems for your Nagpur home. On-grid connects to MSEDCL with net metering, off-grid works independently with batteries, hybrid offers both. Most Nagpur homes benefit from on-grid systems due to reliable MSEDCL connection and net metering benefits.",
//       detailedContent: "For Nagpur residential properties: 1) On-grid solar system - Best for areas with reliable MSEDCL supply, allows selling excess power, lowest cost. 2) Off-grid solar system - Essential for areas with frequent power cuts, requires battery investment. 3) Hybrid system - Combines both, automatically switches during outages. Considering Nagpur's power reliability, 80% of our installations are on-grid with net metering. We assess your location, consumption pattern, and backup needs to recommend the optimal system for your Nagpur home.",
//       image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
//       readTime: "7 min read",
//       tags: ["System Types", "On-Grid", "Off-Grid", "Hybrid", "Nagpur Solutions"],
//       localKeywords: ["on grid solar system", "off grid solar Nagpur", "hybrid solar Maharashtra"],
//       slug: "on-grid-off-grid-hybrid-solar-nagpur",
//     },
//   ];

//   const services = [
//     {
//       id: 1,
//       title: "Residential Solar Installation Nagpur",
//       description: "Complete rooftop solar solutions for Nagpur homes with Maharashtra government subsidy support. We specialize in customized solar panel installation in Nagpur for maximum efficiency and savings.",
//       icon: "🏠",
//       image: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
//       link: "/services/residential-solar-nagpur",
//     },
//     {
//       id: 2,
//       title: "Commercial Solar Solutions Nagpur",
//       description: "Industrial and commercial solar installation Nagpur for factories, offices, and businesses. Reduce operational costs with our tailored commercial solar energy systems.",
//       icon: "🏢",
//       image: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
//       link: "/services/commercial-solar-nagpur",
//     },
//     {
//       id: 3,
//       title: "Solar Maintenance & Repair Nagpur",
//       description: "Professional solar panel maintenance, cleaning, and repair services in Nagpur. Ensure optimal performance of your solar investment with our expert technicians.",
//       icon: "🔧",
//       image: "https://images.unsplash.com/photo-1624395213043-fa2e123b2656?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
//       link: "/services/solar-maintenance-nagpur",
//     },
//   ];

//   const researchStudies = [
//     {
//       id: 1,
//       title: "Solar Adoption Trends in Nagpur 2025",
//       description: "Research shows 300% growth in residential solar installations in Nagpur over last 3 years. Factors driving growth: rising electricity costs, improved subsidies, and increased awareness about renewable energy benefits.",
//       icon: "📈",
//       image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
//       link: "/research/nagpur-solar-trends",
//     },
//     {
//       id: 2,
//       title: "ROI Analysis: Solar vs Conventional Power in Maharashtra",
//       description: "Comparative study showing solar systems in Maharashtra offer 18-25% annual ROI compared to 8-10% from traditional investments. Nagpur leads in commercial solar adoption due to industrial growth.",
//       icon: "💰",
//       image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
//       link: "/research/solar-roi-maharashtra",
//     },
//     {
//       id: 3,
//       title: "Impact of Solar on Nagpur's Carbon Footprint",
//       description: "Study reveals Nagpur's installed solar capacity has reduced CO2 emissions by 45,000 tons annually. Each 1kW residential solar system prevents 1.5 tons of carbon emissions yearly.",
//       icon: "🌍",
//       image: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
//       link: "/research/carbon-reduction-nagpur",
//     },
//   ];

//   const popularServices = [
//     {
//       id: 1,
//       title: "Solar Panel Installation Nagpur",
//       description: "Professional solar panel installation in Nagpur with warranty and subsidy support",
//       image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
//       link: "/services/installation-nagpur",
//     },
//     {
//       id: 2,
//       title: "Solar Subsidy Assistance Nagpur",
//       description: "Complete assistance for Maharashtra solar subsidy application and disbursement",
//       image: "https://images.unsplash.com/photo-1542332213-9b5a5a3fad55?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
//       link: "/services/subsidy-assistance",
//     },
//     {
//       id: 3,
//       title: "Solar System Maintenance Nagpur",
//       description: "Annual maintenance contracts for solar systems in Nagpur and surrounding areas",
//       image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
//       link: "/services/maintenance-nagpur",
//     },
//     {
//       id: 4,
//       title: "Free Solar Consultation Nagpur",
//       description: "Free site survey and consultation for solar panel installation in Nagpur",
//       image: "https://images.unsplash.com/photo-1509316785289-025f5b846b35?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
//       link: "/services/free-consultation",
//     },
//   ];

//   const faqItems = [
//     {
//       question: "How much does solar panel installation cost in Nagpur?",
//       answer: "For a typical 3kW residential solar system in Nagpur, costs range from ₹1.5-2 lakhs after subsidies. Commercial installations vary based on capacity and requirements.",
//     },
//     {
//       question: "What solar subsidy is available in Maharashtra?",
//       answer: "Maharashtra offers 20-40% subsidy: ₹14,000/kW for first 3kW, ₹7,000/kW for next 3kW for residential installations through MSEDCL portal.",
//     },
//     {
//       question: "How many units does 1kW solar generate in Nagpur?",
//       answer: "In Nagpur, 1kW solar system generates 4-5 units daily (120-150 units monthly), depending on season and panel orientation.",
//     },
//     {
//       question: "What maintenance do solar panels need in Nagpur?",
//       answer: "Solar panels in Nagpur need quarterly cleaning (more during summer), annual inspection, and inverter maintenance every 5 years.",
//     },
//   ];

//   const localKeywords = [
//     "Solar Panel Installation in Nagpur",
//     "Solar Company in Nagpur",
//     "Rooftop Solar Nagpur",
//     "Residential Solar System Nagpur",
//     "Commercial Solar Installation Nagpur",
//     "Solar Panel Price in Nagpur",
//     "Solar Subsidy Maharashtra",
//     "Best Solar Company Nagpur",
//     "On Grid Solar System Nagpur",
//     "Off Grid Solar System Nagpur",
//   ];

//   const categories = [
//     "Educational Guides",
//     "Cost and Savings Analysis",
//     "Customer Stories and Case Studies",
//     "Myth Busting",
//     "Industry News and Innovations",
//     "Step-by-Step Process",
//     "Environmental Benefits",
//   ];

//   // Chatbot functions
//   const initChat = () => {
//     addChatMessage("Hi 👋 Welcome to Blue Sky Energy Solar Blog! I'm here to help you with solar information, blog topics, and expert advice. How can I assist you today?", 'bot');
//     setTimeout(() => {
//       addChatMessage("Choose an option to get started:", 'bot');
//       setQuickReplies([
//         "📖 Read Blog Articles", 
//         "💰 Calculate Savings", 
//         "📞 Free Consultation",
//         "🏠 Residential Solar",
//         "🏢 Commercial Solar"
//       ]);
//     }, 800);
//   };

//   const addChatMessage = (text, sender) => {
//     const time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//     const newMessage = {
//       text,
//       sender,
//       time,
//       id: Date.now()
//     };
//     setChatMessages(prev => [...prev, newMessage]);
//     if (sender === 'user') {
//       setMessageCount(prev => prev + 1);
//     }
//   };

//   const matchKeywords = (input) => {
//     const text = input.toLowerCase();
    
//     if (text.includes('blog') || text.includes('article') || text.includes('read')) {
//       return "📖 Blog Articles\n\nWe have 6+ detailed solar articles:\n1. How Solar Panels Work - Beginner's Guide\n2. Solar Investment ROI in Nagpur 2026\n3. 500kW Manufacturing Plant Case Study\n4. Debunking 7 Solar Myths\n5. Solar Subsidy Process Guide\n6. On-Grid vs Off-Grid Systems\n\nWhich topic interests you?";
//     }
    
//     if (text.includes('save') || text.includes('saving') || text.includes('cost') || text.includes('roi')) {
//       return "💰 Solar Savings Calculator\n\nFor Nagpur Residents:\n• 3kW System: Saves ₹2,500-3,500/month\n• 5kW System: Saves ₹4,500-6,000/month\n• ROI: 5-7 years after subsidy\n• 25+ years of free electricity after ROI\n\nCommercial:\n• 40kW: Saves ₹88,000/month\n• 500kW: Saves ₹2.2L/month\n\nWant a personalized savings estimate?";
//     }
    
//     if (text.includes('residential') || text.includes('home') || text.includes('house')) {
//       return "🏠 Residential Solar Nagpur\n\n• Typical Cost: ₹1.5-2 lakhs (3kW after subsidy)\n• Monthly Savings: ₹2,500-3,500\n• Payback: 5-7 years\n• Subsidy: 20-40% from Maharashtra Govt\n• Process: 3-7 days installation\n• Warranty: 25 years on panels\n\nWe've installed 1000+ residential systems in Nagpur!";
//     }
    
//     if (text.includes('commercial') || text.includes('business') || text.includes('factory') || text.includes('industrial')) {
//       return "🏢 Commercial Solar Nagpur\n\n• ROI: 3-5 years\n• Tax Benefits: 40% accelerated depreciation\n• Subsidy: Up to 30% for MSME\n• Common Sizes: 10kW to 500kW+\n• Maintenance: 0.5-1% annual cost\n• Case Studies Available\n\nPerfect for Nagpur industries in Butibori & Hingna!";
//     }
    
//     if (text.includes('subsidy') || text.includes('government') || text.includes('msedcl')) {
//       return "🏛️ Maharashtra Solar Subsidy\n\n• Residential: ₹14,000/kW (1-3kW)\n• Residential: ₹7,000/kW (4-10kW)\n• MSME: Up to 30% subsidy\n• Process: MSEDCL portal registration\n• Timeline: 30-45 days disbursement\n• We handle all paperwork!\n\nNeed help with subsidy application?";
//     }
    
//     if (text.includes('install') || text.includes('process') || text.includes('time')) {
//       return "⚙️ Installation Process\n\n1. Free Site Survey (1-2 days)\n2. Custom Design & Quote (1 day)\n3. Subsidy Application (we handle)\n4. Installation (3-7 days)\n5. Commissioning & Training (1 day)\n6. Subsidy Receipt (30-45 days)\n\nComplete process: 45-60 days from start to subsidy!";
//     }
    
//     if (text.includes('maintenance') || text.includes('repair') || text.includes('clean')) {
//       return "🔧 Solar Maintenance\n\n• Cleaning: Quarterly (monsoon: monthly)\n• Inspection: Annual professional check\n• Inverter Service: Every 5 years\n• Warranty: 25 years panels, 10 years inverter\n• Monitoring: Free app for tracking\n• Emergency Support: 24/7 in Nagpur\n\nWe offer AMC starting at ₹2,000/year!";
//     }
    
//     if (text.includes('consult') || text.includes('free') || text.includes('quote') || text.includes('meet')) {
//       return "📞 Free Consultation\n\n• Free Site Assessment\n• Custom Solar Design\n• ROI Calculation\n• Subsidy Assistance\n• Financing Options\n• 5000+ Happy Customers Trust Us!\n\nPerfect time to switch - subsidies available!";
//     }
    
//     if (text.includes('nagpur') || text.includes('location') || text.includes('area')) {
//       return "📍 Solar in Nagpur\n\n• Ideal Location: 300 sunny days/year\n• Peak Sun Hours: 6-7 daily\n• Common Installations: Residential, Commercial, Industrial\n• Popular Areas: Civil Lines, Wardha Road, Butibori, Hingna\n• Local Support: Our office in Nagpur\n• Experience: 10+ years serving Nagpur!\n\nWe're Nagpur's trusted Blue Sky Energy company!";
//     }
    
//     return "I understand you're interested in solar energy! As Nagpur's leading solar blog, I can help with:\n• Blog articles & guides\n• Cost & savings calculations\n• Subsidy information\n• Installation process\n• Residential vs commercial systems\n• Maintenance tips\n\nWhat would you like to know more about?";
//   };

//   const handleLeadCapture = (input) => {
//     if (leadStep === 0) {
//       setUserData(prev => ({ ...prev, name: input }));
//       setLeadStep(1);
//       addChatMessage(`Nice to meet you, ${input}! 😊\n\nCould you please share your phone number so our solar experts can contact you?`, 'bot');
//     } else if (leadStep === 1) {
//       setUserData(prev => ({ ...prev, phone: input }));
//       setLeadStep(2);
//       addChatMessage("Great! And which area in Nagpur are you from?", 'bot');
//     } else if (leadStep === 2) {
//       setUserData(prev => ({ ...prev, city: input }));
//       setLeadCaptured(true);
//       setAwaitingLeadInfo(false);
//       saveLead({ ...userData, city: input });
//       addChatMessage(`Perfect! Thank you ${userData.name}! ✅\n\nOur solar expert will contact you within 24 hours with:\n1. Free site assessment\n2. Customized solar design\n3. ROI calculation\n4. Subsidy guidance\n\nJoin 5000+ happy solar customers in Nagpur!`, 'bot');
//     }
//   };

//   const saveLead = (data) => {
//     const leadId = `blog_lead_${Date.now()}`;
//     localStorage.setItem(leadId, JSON.stringify({...data, timestamp: new Date(), source: 'blog_chatbot'}));
//     console.log("Blog Page Lead Saved:", data);
//   };

//   const handleChatSend = () => {
//     const text = chatInput.trim();
//     if (!text) return;

//     addChatMessage(text, 'user');
//     setChatInput('');
//     setQuickReplies([]);

//     setTimeout(() => {
//       if (awaitingLeadInfo) {
//         handleLeadCapture(text);
//       } else {
//         const response = matchKeywords(text);
//         addChatMessage(response, 'bot');

//         if (!leadCaptured && messageCount >= 1) {
//           setTimeout(() => {
//             addChatMessage("Want personalized solar advice? 📋\n\nCan I get your name to connect you with our solar experts?", 'bot');
//             setAwaitingLeadInfo(true);
//           }, 1500);
//         }
//       }
//     }, 600);
//   };

//   const handleQuickReply = (option) => {
//     setChatInput(option);
//     setTimeout(() => {
//       handleChatSend();
//     }, 100);
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       handleChatSend();
//     }
//   };

//   return (
//     <div style={{
//       fontFamily: "Cambria, serif",
//       backgroundColor: "#ffffff",
//       minHeight: "100vh",
//       color: "#123249",
//       overflowX: "hidden"
//     }}>
//       {/* Responsive CSS - Blue Sky Energy Theme */}
//       <style>
//         {`
//           :root {
//             --color-deep-teal: #061221;
//             --color-dark-navy: #123249;
//             --color-midnight: #2D5A74;
//             --color-slate: #447793;
//             --color-frost: #DDE8ED;
//             --color-white: #ffffff;
//             --gradient-primary: linear-gradient(135deg, #447793 0%, #2D5A74 100%);
//             --gradient-hover: linear-gradient(135deg, #2D5A74 0%, #123249 100%);
//             --gradient-light: linear-gradient(135deg, #DDE8ED 0%, #ffffff 100%);
//             --shadow-sm: 0 2px 15px rgba(6, 18, 33, 0.08);
//             --shadow-md: 0 4px 20px rgba(6, 18, 33, 0.12);
//             --shadow-lg: 0 10px 30px rgba(6, 18, 33, 0.15);
//           }

//           @keyframes fadeIn {
//             from { opacity: 0; transform: translateY(10px); }
//             to { opacity: 1; transform: translateY(0); }
//           }
          
//           @keyframes pulse {
//             0% { transform: scale(1); }
//             50% { transform: scale(1.05); }
//             100% { transform: scale(1); }
//           }
          
//           /* Mobile Responsive Styles */
//           @media (max-width: 768px) {
//             .header-title {
//               font-size: 1.8rem !important;
//               padding: 0 15px;
//             }
            
//             .header-subtitle {
//               font-size: 1rem !important;
//               padding: 0 15px;
//             }
            
//             .section-title {
//               font-size: 1.8rem !important;
//             }
            
//             .section-subtitle {
//               font-size: 1rem !important;
//               padding: 0 10px;
//             }
            
//             .blog-post {
//               grid-template-columns: 1fr !important;
//               gap: 30px !important;
//             }
            
//             .blog-image {
//               height: 250px !important;
//               order: -1;
//             }
            
//             .blog-title {
//               font-size: 1.5rem !important;
//             }
            
//             .vision-container {
//               grid-template-columns: 1fr !important;
//               gap: 30px !important;
//             }
            
//             .vision-content {
//               padding-right: 0 !important;
//               padding-bottom: 30px;
//             }
            
//             .vision-points {
//               grid-template-columns: 1fr !important;
//               gap: 20px !important;
//             }
            
//             .service-grid,
//             .research-grid,
//             .popular-grid,
//             .categories-grid,
//             .keyword-grid {
//               grid-template-columns: 1fr !important;
//             }
            
//             .chat-window {
//               width: 90vw !important;
//               right: 5vw !important;
//               left: 5vw !important;
//               bottom: 90px !important;
//               height: 500px !important;
//               max-height: 70vh !important;
//             }
            
//             .chat-toggle-btn {
//               width: 55px !important;
//               height: 55px !important;
//               bottom: 20px !important;
//               right: 20px !important;
//             }
            
//             .chat-messages {
//               max-height: 300px !important;
//             }
            
//             .message {
//               max-width: 85% !important;
//               font-size: 13px !important;
//               padding: 10px 14px !important;
//             }
            
//             .quick-replies {
//               flex-wrap: wrap !important;
//             }
            
//             .reply-btn {
//               font-size: 12px !important;
//               padding: 6px 12px !important;
//               margin: 2px !important;
//             }
            
//             .cta-buttons {
//               flex-direction: column !important;
//               gap: 15px !important;
//             }
            
//             .cta-button {
//               width: 100% !important;
//               text-align: center;
//             }
            
//             .main-content {
//               padding: 20px 15px !important;
//             }
            
//             .service-section,
//             .research-section,
//             .vision-section,
//             .popular-services-section,
//             .faq-section {
//               padding: 40px 15px !important;
//             }
//           }
          
//           @media (max-width: 480px) {
//             .header-title {
//               font-size: 1.5rem !important;
//               padding: 0 10px;
//             }
            
//             .header-subtitle {
//               font-size: 0.9rem !important;
//               padding: 0 10px;
//             }
            
//             .section-title {
//               font-size: 1.5rem !important;
//             }
            
//             .blog-title {
//               font-size: 1.3rem !important;
//             }
            
//             .blog-image {
//               height: 200px !important;
//             }
            
//             .category-item {
//               padding: 12px !important;
//               font-size: 0.9rem !important;
//             }
            
//             .keyword-tag {
//               font-size: 0.8rem !important;
//               padding: 6px 12px !important;
//             }
            
//             .chat-window {
//               width: 95vw !important;
//               right: 2.5vw !important;
//               left: 2.5vw !important;
//             }
            
//             .chat-input {
//               font-size: 13px !important;
//               padding: 10px 14px !important;
//             }
            
//             .send-btn {
//               width: 40px !important;
//               height: 40px !important;
//               font-size: 14px !important;
//             }
            
//             .tags-container {
//               gap: 5px !important;
//             }
            
//             .tag {
//               font-size: 0.7rem !important;
//               padding: 4px 8px !important;
//             }
//           }
          
//           @media (min-width: 769px) and (max-width: 1024px) {
//             .blog-post {
//               gap: 30px !important;
//             }
            
//             .blog-image {
//               height: 300px !important;
//             }
            
//             .service-grid,
//             .research-grid {
//               grid-template-columns: repeat(2, 1fr) !important;
//             }
            
//             .popular-grid {
//               grid-template-columns: repeat(2, 1fr) !important;
//             }
            
//             .categories-grid {
//               grid-template-columns: repeat(3, 1fr) !important;
//             }
            
//             .chat-window {
//               width: 350px !important;
//             }
//           }
          
//           /* Touch-friendly styles for mobile */
//           @media (hover: none) and (pointer: coarse) {
//             .service-card:hover,
//             .research-card:hover,
//             .popular-card:hover {
//               transform: none !important;
//             }
            
//             .category-item:hover,
//             .keyword-tag:hover {
//               transform: none !important;
//             }
            
//             .read-more:hover,
//             .learn-more:hover,
//             .more-button:hover,
//             .view-more:hover {
//               padding-left: 0 !important;
//               gap: 5px !important;
//             }
//           }
          
//           /* Prevent zoom on mobile input */
//           @media (max-width: 768px) {
//             input, textarea, select {
//               font-size: 16px !important;
//             }
//           }
          
//           /* Smooth scrolling */
//           html {
//             scroll-behavior: smooth;
//           }
//         `}
//       </style>

//       {/* Header - Blue Theme */}
//       <header style={{
//         background: "linear-gradient(rgba(18, 50, 73, 0.95), rgba(45, 90, 116, 0.95))",
//         color: "white",
//         padding: "80px 20px 50px",
//         textAlign: "center",
//         position: "relative",
//         overflow: "hidden"
//       }}>
//         <h1 className="header-title" style={{
//           fontSize: "2.8rem",
//           fontWeight: "800",
//           marginBottom: "20px",
//           textShadow: "2px 2px 4px rgba(6, 18, 33, 0.3)",
//           maxWidth: "900px",
//           margin: "0 auto 20px",
//           color: "#ffffff"
//         }}>
//           Solar Panel Installation Blog Nagpur | Expert Guides & Tips
//         </h1>
//         <p className="header-subtitle" style={{
//           fontSize: "1.2rem",
//           maxWidth: "800px",
//           margin: "0 auto 30px",
//           opacity: "0.95",
//           lineHeight: "1.6",
//           color: "#DDE8ED"
//         }}>
//           Discover the latest in solar technology, installation guides, cost analysis for Nagpur, Maharashtra solar subsidy information, and renewable energy solutions for residential & commercial properties in Nagpur.
//         </p>
//       </header>

//       {/* Main Content */}
//       <main style={{
//         maxWidth: "1200px",
//         margin: "0 auto",
//         padding: "30px 20px",
//         width: "100%",
//         boxSizing: "border-box"
//       }}>

//         {/* SEO Banner - Blue Theme */}
//         <div style={{
//           backgroundColor: "#DDE8ED",
//           borderLeft: "5px solid #447793",
//           padding: "25px",
//           borderRadius: "10px",
//           marginBottom: "40px",
//           boxShadow: "0 5px 15px rgba(6, 18, 33, 0.05)",
//         }}>
//           <h2 style={{
//             fontSize: "1.5rem",
//             fontWeight: "700",
//             color: "#123249",
//             marginBottom: "15px",
//           }}>
//             Looking for Solar Panel Installation in Nagpur?
//           </h2>
//           <p style={{
//             color: "#2D5A74",
//             fontSize: "1rem",
//             lineHeight: "1.7",
//             marginBottom: "15px",
//           }}>
//             As Nagpur's leading solar company, we provide comprehensive solar solutions including <strong>residential solar system Nagpur</strong>, <strong>commercial solar installation Nagpur</strong>, and <strong>rooftop solar Nagpur</strong> services. Get expert guidance on <strong>Maharashtra solar subsidy</strong> and find the best <strong>solar panel price in Nagpur</strong>.
//           </p>
//           <p style={{
//             color: "#2D5A74",
//             fontSize: "1rem",
//             lineHeight: "1.7",
//             marginBottom: "15px",
//           }}>
//             Our blog covers everything from <strong>on grid solar system</strong> vs <strong>off grid solar system</strong> comparisons to step-by-step guides for <strong>solar panel installation in Nagpur</strong>.
//           </p>
//         </div>

//         {/* Local Keywords Section - Blue Theme */}
//         <section style={{
//           backgroundColor: "#DDE8ED",
//           padding: "25px",
//           borderRadius: "15px",
//           marginTop: "40px",
//           marginBottom: "40px",
//         }}>
//           <div style={{ textAlign: "center", marginBottom: "30px" }}>
//             <h2 className="section-title" style={{
//               fontSize: "2.5rem",
//               fontWeight: "800",
//               color: "#123249",
//               marginBottom: "15px",
//             }}>
//               Solar Services in Nagpur
//             </h2>
//             <p className="section-subtitle" style={{
//               fontSize: "1.1rem",
//               color: "#2D5A74",
//               maxWidth: "800px",
//               margin: "0 auto",
//               lineHeight: "1.6",
//             }}>
//               Searching for these solar solutions in Nagpur? Click for detailed information:
//             </p>
//           </div>
//           <div className="keyword-grid" style={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: "10px",
//             justifyContent: "center",
//             marginTop: "20px",
//           }}>
//             {localKeywords.map((keyword, index) => (
//               <a
//                 key={index}
//                 href={`/services/${keyword.toLowerCase().replace(/\s+/g, "-")}`}
//                 className="keyword-tag"
//                 style={{
//                   backgroundColor: "white",
//                   color: "#123249",
//                   padding: "8px 16px",
//                   borderRadius: "20px",
//                   fontSize: "0.9rem",
//                   fontWeight: "600",
//                   border: "2px solid #DDE8ED",
//                   transition: "all 0.3s ease",
//                   cursor: "pointer",
//                   textDecoration: "none",
//                   display: "inline-block",
//                 }}
//                 onMouseEnter={(e) => {
//                   e.target.style.backgroundColor = "#447793";
//                   e.target.style.color = "white";
//                   e.target.style.borderColor = "#447793";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.backgroundColor = "white";
//                   e.target.style.color = "#123249";
//                   e.target.style.borderColor = "#DDE8ED";
//                 }}
//               >
//                 {keyword}
//               </a>
//             ))}
//           </div>
//         </section>

//         {/* Service Section - Blue Theme */}
//         <section style={{
//           backgroundColor: "#ffffff",
//           padding: "60px 20px",
//           marginTop: "40px",
//         }}>
//           <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//             <div style={{ textAlign: "center", marginBottom: "40px" }}>
//               <h2 className="section-title" style={{
//                 fontSize: "2.5rem",
//                 fontWeight: "800",
//                 color: "#123249",
//                 marginBottom: "15px",
//               }}>
//                 OUR SOLAR SERVICES IN NAGPUR
//               </h2>
//               <p className="section-subtitle" style={{
//                 fontSize: "1.1rem",
//                 color: "#2D5A74",
//                 maxWidth: "800px",
//                 margin: "0 auto",
//                 lineHeight: "1.6",
//               }}>
//                 As a premier solar company in Nagpur, we provide comprehensive solar panel installation services for residential, commercial, and industrial properties across Nagpur and Maharashtra.
//                 Specializing in customized solar solutions with full subsidy support and professional installation.
//               </p>
//             </div>

//             <div className="service-grid" style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//               gap: "25px",
//               marginTop: "30px",
//             }}>
//               {services.map((service) => (
//                 <a
//                   href={service.link}
//                   key={service.id}
//                   style={{ textDecoration: "none" }}
//                 >
//                   <div className="service-card" style={{
//                     backgroundColor: "white",
//                     borderRadius: "15px",
//                     overflow: "hidden",
//                     boxShadow: "0 10px 30px rgba(6, 18, 33, 0.08)",
//                     transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
//                     position: "relative",
//                     cursor: "pointer",
//                     border: "1px solid #DDE8ED"
//                   }}>
//                     <img
//                       src={service.image}
//                       alt={`${service.title} - Solar Company Nagpur`}
//                       style={{
//                         width: "100%",
//                         height: "200px",
//                         objectFit: "cover",
//                         transition: "transform 0.5s ease",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.transform = "scale(1.1)";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.transform = "scale(1)";
//                       }}
//                     />
//                     <div style={{ padding: "20px" }}>
//                       <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>{service.icon}</div>
//                       <h3 style={{
//                         fontSize: "1.4rem",
//                         fontWeight: "700",
//                         color: "#123249",
//                         marginBottom: "10px",
//                       }}>{service.title}</h3>
//                       <p style={{
//                         color: "#2D5A74",
//                         fontSize: "0.95rem",
//                         lineHeight: "1.6",
//                         marginBottom: "20px",
//                       }}>
//                         {service.description}
//                       </p>
//                       <div style={{
//                         color: "#447793",
//                         fontWeight: "600",
//                         textDecoration: "none",
//                         fontSize: "0.95rem",
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "5px",
//                         transition: "all 0.3s ease",
//                       }}>
//                         Get Free Quote →
//                       </div>
//                     </div>
//                   </div>
//                 </a>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* Research Section - Blue Theme */}
//         <section style={{
//           padding: "60px 20px",
//           backgroundColor: "#DDE8ED",
//           borderRadius: "15px"
//         }}>
//           <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//             <div style={{ textAlign: "center", marginBottom: "40px" }}>
//               <h2 className="section-title" style={{
//                 fontSize: "2.5rem",
//                 fontWeight: "800",
//                 color: "#123249",
//                 marginBottom: "15px",
//               }}>
//                 Solar Research & Case Studies - Nagpur
//               </h2>
//               <p className="section-subtitle" style={{
//                 fontSize: "1.1rem",
//                 color: "#2D5A74",
//                 maxWidth: "800px",
//                 margin: "0 auto",
//                 lineHeight: "1.6",
//               }}>
//                 Data-driven insights on solar adoption, ROI analysis, and environmental impact studies specific to Nagpur and Maharashtra region.
//               </p>
//             </div>

//             <div className="research-grid" style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//               gap: "25px",
//               marginTop: "30px",
//             }}>
//               {researchStudies.map((study) => (
//                 <a
//                   href={study.link}
//                   key={study.id}
//                   style={{ textDecoration: "none" }}
//                 >
//                   <div className="research-card" style={{
//                     backgroundColor: "white",
//                     borderRadius: "15px",
//                     padding: "25px",
//                     transition: "all 0.3s ease",
//                     border: "2px solid transparent",
//                     boxShadow: "0 10px 30px rgba(6, 18, 33, 0.08)"
//                   }}>
//                     <div style={{ fontSize: "2.2rem", marginBottom: "20px" }}>{study.icon}</div>
//                     <h3 style={{
//                       fontSize: "1.3rem",
//                       fontWeight: "700",
//                       color: "#123249",
//                       marginBottom: "15px",
//                     }}>{study.title}</h3>
//                     <p style={{
//                       color: "#2D5A74",
//                       fontSize: "0.95rem",
//                       lineHeight: "1.6",
//                       marginBottom: "25px",
//                     }}>
//                       {study.description}
//                     </p>
//                     <div style={{
//                       display: "inline-block",
//                       backgroundColor: "#447793",
//                       color: "white",
//                       padding: "10px 25px",
//                       borderRadius: "25px",
//                       fontWeight: "600",
//                       textDecoration: "none",
//                       fontSize: "0.9rem",
//                       transition: "all 0.3s ease",
//                     }}>
//                       READ STUDY →
//                     </div>
//                   </div>
//                 </a>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* FAQ Section - Blue Theme */}
//         <section style={{
//           backgroundColor: "#ffffff",
//           padding: "50px 25px",
//           borderRadius: "15px",
//           marginTop: "50px",
//           marginBottom: "50px",
//           border: "1px solid #DDE8ED"
//         }}>
//           <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//             <div style={{ textAlign: "center", marginBottom: "40px" }}>
//               <h2 className="section-title" style={{
//                 fontSize: "2.5rem",
//                 fontWeight: "800",
//                 color: "#123249",
//                 marginBottom: "15px",
//               }}>
//                 Frequently Asked Questions - Solar Nagpur
//               </h2>
//               <p className="section-subtitle" style={{
//                 fontSize: "1.1rem",
//                 color: "#2D5A74",
//                 maxWidth: "800px",
//                 margin: "0 auto",
//                 lineHeight: "1.6",
//               }}>
//                 Common questions about solar panel installation, costs, subsidies, and maintenance in Nagpur, Maharashtra.
//               </p>
//             </div>

//             <div style={{ marginTop: "30px" }}>
//               {faqItems.map((faq, index) => (
//                 <div key={index} style={{
//                   backgroundColor: "#DDE8ED",
//                   padding: "25px",
//                   borderRadius: "10px",
//                   marginBottom: "20px",
//                   boxShadow: "0 5px 15px rgba(6, 18, 33, 0.05)",
//                   borderLeft: "4px solid #447793",
//                 }}>
//                   <h3 style={{
//                     fontSize: "1.2rem",
//                     fontWeight: "700",
//                     color: "#123249",
//                     marginBottom: "15px",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "10px",
//                   }}>
//                     ❓ {faq.question}
//                   </h3>
//                   <p style={{
//                     color: "#2D5A74",
//                     fontSize: "1rem",
//                     lineHeight: "1.7",
//                     paddingLeft: "30px",
//                   }}>
//                     {faq.answer}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* Vision Section - Blue Theme */}
//         <section style={{
//           padding: "60px 20px",
//           background: "linear-gradient(135deg, #DDE8ED 0%, #ffffff 100%)",
//           borderRadius: "15px"
//         }}>
//           <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//             <div className="vision-container" style={{
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               gap: "50px",
//               alignItems: "center",
//             }}>
//               <div className="vision-content" style={{ paddingRight: "40px" }}>
//                 <h2 className="section-title" style={{
//                   fontSize: "2.2rem",
//                   fontWeight: "800",
//                   color: "#123249",
//                   marginBottom: "20px",
//                 }}>
//                   Our Vision for Solar Energy in Nagpur
//                 </h2>
//                 <h3 style={{
//                   fontSize: "1.8rem",
//                   fontWeight: "700",
//                   color: "#447793",
//                   marginBottom: "30px",
//                 }}>
//                   Leading Nagpur's Solar Revolution
//                 </h3>
//                 <p style={{
//                   color: "#2D5A74",
//                   fontSize: "1rem",
//                   lineHeight: "1.7",
//                   marginBottom: "25px",
//                 }}>
//                   We envision making Nagpur a solar-powered city by 2030, with every home and business benefiting from clean, affordable solar energy. As Nagpur's trusted Blue Sky Energy solar company, we're committed to providing top-quality solar panel installation in Nagpur with comprehensive support for Maharashtra solar subsidy applications.
//                 </p>
//                 <p style={{
//                   color: "#2D5A74",
//                   fontSize: "1rem",
//                   lineHeight: "1.7",
//                   marginBottom: "25px",
//                 }}>
//                   Our mission extends beyond installation - we aim to educate Nagpur residents about the benefits of rooftop solar Nagpur systems, help them navigate the solar subsidy process in Maharashtra, and provide ongoing maintenance for optimal system performance.
//                 </p>
//               </div>

//               <div className="vision-points" style={{
//                 display: "grid",
//                 gridTemplateColumns: "1fr 1fr",
//                 gap: "25px",
//                 marginTop: "0",
//               }}>
//                 <div style={{
//                   backgroundColor: "white",
//                   padding: "25px",
//                   borderRadius: "12px",
//                   boxShadow: "0 5px 15px rgba(6, 18, 33, 0.05)",
//                   border: "1px solid #DDE8ED"
//                 }}>
//                   <h4 style={{
//                     fontSize: "1.2rem",
//                     fontWeight: "700",
//                     color: "#123249",
//                     marginBottom: "10px",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "10px",
//                   }}>
//                     🎯 Nagpur Solar Target
//                   </h4>
//                   <p style={{
//                     color: "#2D5A74",
//                     fontSize: "0.95rem",
//                     lineHeight: "1.6",
//                   }}>
//                     Install 10,000+ solar systems across Nagpur by 2027, reducing carbon emissions by 50,000 tons annually and helping residents save ₹50+ crores on electricity bills.
//                   </p>
//                 </div>
//                 <div style={{
//                   backgroundColor: "white",
//                   padding: "25px",
//                   borderRadius: "12px",
//                   boxShadow: "0 5px 15px rgba(6, 18, 33, 0.05)",
//                   border: "1px solid #DDE8ED"
//                 }}>
//                   <h4 style={{
//                     fontSize: "1.2rem",
//                     fontWeight: "700",
//                     color: "#123249",
//                     marginBottom: "10px",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "10px",
//                   }}>
//                     💡 Technology & Innovation
//                   </h4>
//                   <p style={{
//                     color: "#2D5A74",
//                     fontSize: "0.95rem",
//                     lineHeight: "1.6",
//                   }}>
//                     Implementing AI-powered monitoring for all solar installations in Nagpur, smart grid integration, and next-generation battery storage solutions tailored for Nagpur's climate.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Popular Services Section - Blue Theme */}
//         <section style={{
//           padding: "60px 20px",
//           backgroundColor: "#ffffff",
//         }}>
//           <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//             <div style={{ textAlign: "center", marginBottom: "40px" }}>
//               <h2 className="section-title" style={{
//                 fontSize: "2.5rem",
//                 fontWeight: "800",
//                 color: "#123249",
//                 marginBottom: "15px",
//               }}>
//                 Most Popular Solar Services in Nagpur
//               </h2>
//               <p className="section-subtitle" style={{
//                 fontSize: "1.1rem",
//                 color: "#2D5A74",
//                 maxWidth: "800px",
//                 margin: "0 auto",
//                 lineHeight: "1.6",
//               }}>
//                 Services most requested by our Nagpur customers for residential and commercial solar solutions.
//               </p>
//             </div>

//             <div className="popular-grid" style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//               gap: "25px",
//               marginTop: "30px",
//             }}>
//               {popularServices.map((service) => (
//                 <a
//                   href={service.link}
//                   key={service.id}
//                   style={{ textDecoration: "none" }}
//                 >
//                   <div className="popular-card" style={{
//                     backgroundColor: "#DDE8ED",
//                     borderRadius: "12px",
//                     padding: "25px",
//                     textAlign: "center",
//                     transition: "all 0.3s ease",
//                     border: "2px solid transparent",
//                     cursor: "pointer",
//                   }}>
//                     <h3 style={{
//                       fontSize: "1.3rem",
//                       fontWeight: "700",
//                       color: "#123249",
//                       marginBottom: "10px",
//                     }}>{service.title}</h3>
//                     <p style={{
//                       color: "#2D5A74",
//                       fontSize: "0.9rem",
//                       marginBottom: "20px",
//                       lineHeight: "1.6",
//                     }}>
//                       {service.description}
//                     </p>
//                     <div style={{
//                       display: "inline-block",
//                       color: "#447793",
//                       fontWeight: "600",
//                       textDecoration: "none",
//                       fontSize: "0.9rem",
//                     }}>
//                       Get Service Details →
//                     </div>
//                   </div>
//                 </a>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* Blog Categories Section - Blue Theme */}
//         <section style={{
//           backgroundColor: "#DDE8ED",
//           padding: "25px",
//           borderRadius: "15px",
//           marginBottom: "40px",
//           boxShadow: "0 5px 15px rgba(6, 18, 33, 0.05)",
//         }}>
//           <h2 style={{
//             fontSize: "1.8rem",
//             color: "#123249",
//             marginBottom: "25px",
//             textAlign: "center",
//             fontWeight: "700",
//           }}>
//             Browse Solar Topics
//           </h2>
//           <div className="categories-grid" style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
//             gap: "15px",
//             textAlign: "center",
//           }}>
//             {categories.map((category, index) => (
//               <div
//                 key={index}
//                 className="category-item"
//                 style={{
//                   padding: "15px",
//                   backgroundColor: "white",
//                   borderRadius: "10px",
//                   cursor: "pointer",
//                   transition: "all 0.3s ease",
//                   border: "2px solid #DDE8ED",
//                   fontWeight: "600",
//                   color: "#123249",
//                 }}
//                 onMouseEnter={(e) => {
//                   e.target.style.backgroundColor = "#447793";
//                   e.target.style.color = "white";
//                   e.target.style.borderColor = "#447793";
//                   e.target.style.transform = "translateY(-3px)";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.backgroundColor = "white";
//                   e.target.style.color = "#123249";
//                   e.target.style.borderColor = "#DDE8ED";
//                   e.target.style.transform = "translateY(0)";
//                 }}
//               >
//                 {category}
//               </div>
//             ))}
//           </div>
//         </section>

//         {/* Blog Posts Section - Blue Theme */}
//         <section style={{
//           display: "flex",
//           flexDirection: "column",
//           gap: "50px",
//           marginTop: "60px",
//         }}>
//           <div style={{ textAlign: "center", marginBottom: "40px" }}>
//             <h2 className="section-title" style={{
//               fontSize: "2.5rem",
//               fontWeight: "800",
//               color: "#123249",
//               marginBottom: "15px",
//             }}>
//               Latest Solar Insights & Guides for Nagpur
//             </h2>
//             <p className="section-subtitle" style={{
//               fontSize: "1.1rem",
//               color: "#2D5A74",
//               maxWidth: "800px",
//               margin: "0 auto",
//               lineHeight: "1.6",
//             }}>
//               In-depth articles, installation guides, cost analysis, and solar subsidy information specifically for Nagpur, Maharashtra residents and businesses.
//             </p>
//           </div>

//           {blogContent.map((post, index) => (
//             <article
//               key={post.id}
//               className="blog-post"
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "1fr 1fr",
//                 gap: "40px",
//                 alignItems: "center",
//                 paddingBottom: "40px",
//                 borderBottom: "1px solid #DDE8ED",
//               }}
//             >
//               {index % 2 === 0 ? (
//                 <>
//                   <div>
//                     <img
//                       src={post.image}
//                       alt={`${post.title} - Solar Panel Installation Nagpur`}
//                       className="blog-image"
//                       style={{
//                         width: "100%",
//                         height: "350px",
//                         borderRadius: "12px",
//                         objectFit: "cover",
//                         transition: "transform 0.5s ease",
//                         cursor: "pointer",
//                         boxShadow: "0 10px 25px rgba(6, 18, 33, 0.1)",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.transform = "scale(1.05)";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.transform = "scale(1)";
//                       }}
//                     />
//                   </div>
//                   <div style={{ padding: "20px 0" }}>
//                     <span style={{
//                       display: "inline-block",
//                       backgroundColor: "#DDE8ED",
//                       color: "#123249",
//                       padding: "6px 15px",
//                       borderRadius: "20px",
//                       fontSize: "0.85rem",
//                       fontWeight: "600",
//                       marginBottom: "15px",
//                     }}>
//                       {post.category}
//                     </span>
//                     <h3 className="blog-title" style={{
//                       fontSize: "1.8rem",
//                       fontWeight: "700",
//                       color: "#123249",
//                       marginBottom: "15px",
//                       lineHeight: "1.3",
//                     }}>
//                       {post.title}
//                     </h3>
//                     <div style={{
//                       color: "#2D5A74",
//                       fontSize: "0.9rem",
//                       marginBottom: "20px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "20px",
//                       flexWrap: "wrap",
//                     }}>
//                       <span>{post.date}</span>
//                       <span>•</span>
//                       <span>{post.readTime}</span>
//                     </div>
//                     <p style={{
//                       color: "#2D5A74",
//                       fontSize: "1rem",
//                       lineHeight: "1.7",
//                       marginBottom: "25px",
//                     }}>
//                       {post.content}
//                     </p>
//                     <div className="tags-container" style={{
//                       display: "flex",
//                       flexWrap: "wrap",
//                       gap: "10px",
//                       marginTop: "25px",
//                     }}>
//                       {post.tags.map((tag) => (
//                         <span key={tag} style={{
//                           backgroundColor: "#DDE8ED",
//                           color: "#123249",
//                           padding: "6px 12px",
//                           borderRadius: "15px",
//                           fontSize: "0.8rem",
//                           fontWeight: "500",
//                         }}>
//                           {tag}
//                         </span>
//                       ))}
//                     </div>
//                     <p style={{
//                       color: "#2D5A74",
//                       fontSize: "0.95rem",
//                       lineHeight: "1.6",
//                       marginTop: "15px",
//                     }}>
//                       Keywords: {post.localKeywords.join(", ")}
//                     </p>
//                     <a href={`/blog/${post.slug}`} className="read-more" style={{
//                       display: "inline-block",
//                       color: "#447793",
//                       fontWeight: "600",
//                       textDecoration: "none",
//                       fontSize: "1rem",
//                       marginTop: "20px",
//                       padding: "10px 0",
//                       transition: "all 0.3s ease",
//                     }}>
//                       Read Full Article about {post.localKeywords[0]} →
//                     </a>
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   <div style={{ padding: "20px 0" }}>
//                     <span style={{
//                       display: "inline-block",
//                       backgroundColor: "#DDE8ED",
//                       color: "#123249",
//                       padding: "6px 15px",
//                       borderRadius: "20px",
//                       fontSize: "0.85rem",
//                       fontWeight: "600",
//                       marginBottom: "15px",
//                     }}>
//                       {post.category}
//                     </span>
//                     <h3 className="blog-title" style={{
//                       fontSize: "1.8rem",
//                       fontWeight: "700",
//                       color: "#123249",
//                       marginBottom: "15px",
//                       lineHeight: "1.3",
//                     }}>
//                       {post.title}
//                     </h3>
//                     <div style={{
//                       color: "#2D5A74",
//                       fontSize: "0.9rem",
//                       marginBottom: "20px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "20px",
//                       flexWrap: "wrap",
//                     }}>
//                       <span>{post.date}</span>
//                       <span>•</span>
//                       <span>{post.readTime}</span>
//                     </div>
//                     <p style={{
//                       color: "#2D5A74",
//                       fontSize: "1rem",
//                       lineHeight: "1.7",
//                       marginBottom: "25px",
//                     }}>
//                       {post.content}
//                     </p>
//                     <div className="tags-container" style={{
//                       display: "flex",
//                       flexWrap: "wrap",
//                       gap: "10px",
//                       marginTop: "25px",
//                     }}>
//                       {post.tags.map((tag) => (
//                         <span key={tag} style={{
//                           backgroundColor: "#DDE8ED",
//                           color: "#123249",
//                           padding: "6px 12px",
//                           borderRadius: "15px",
//                           fontSize: "0.8rem",
//                           fontWeight: "500",
//                         }}>
//                           {tag}
//                         </span>
//                       ))}
//                     </div>
//                     <p style={{
//                       color: "#2D5A74",
//                       fontSize: "0.95rem",
//                       lineHeight: "1.6",
//                       marginTop: "15px",
//                     }}>
//                       Keywords: {post.localKeywords.join(", ")}
//                     </p>
//                     <a href={`/blog/${post.slug}`} className="read-more" style={{
//                       display: "inline-block",
//                       color: "#447793",
//                       fontWeight: "600",
//                       textDecoration: "none",
//                       fontSize: "1rem",
//                       marginTop: "20px",
//                       padding: "10px 0",
//                       transition: "all 0.3s ease",
//                     }}>
//                       Read Full Article about {post.localKeywords[0]} →
//                     </a>
//                   </div>
//                   <div>
//                     <img
//                       src={post.image}
//                       alt={`${post.title} - Solar Company Nagpur`}
//                       className="blog-image"
//                       style={{
//                         width: "100%",
//                         height: "350px",
//                         borderRadius: "12px",
//                         objectFit: "cover",
//                         transition: "transform 0.5s ease",
//                         cursor: "pointer",
//                         boxShadow: "0 10px 25px rgba(6, 18, 33, 0.1)",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.transform = "scale(1.05)";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.transform = "scale(1)";
//                       }}
//                     />
//                   </div>
//                 </>
//               )}
//             </article>
//           ))}
//         </section>

//         {/* Call to Action Section - Blue Theme */}
//         <section style={{
//           backgroundColor: "#123249",
//           color: "white",
//           padding: "60px 20px",
//           textAlign: "center",
//           borderRadius: "15px",
//           marginTop: "50px",
//           marginBottom: "50px",
//         }}>
//           <h2 style={{
//             fontSize: "2.2rem",
//             fontWeight: "800",
//             marginBottom: "20px",
//             color: "#ffffff"
//           }}>
//             Ready for Solar Panel Installation in Nagpur?
//           </h2>
//           <p style={{
//             fontSize: "1.2rem",
//             maxWidth: "800px",
//             margin: "0 auto 40px",
//             lineHeight: "1.6",
//             color: "#DDE8ED"
//           }}>
//             Get a free solar consultation for your Nagpur home or business. We'll assess your needs, explain Maharashtra solar subsidy options, and provide a customized quote for solar panel installation in Nagpur.
//           </p>
//           <div className="cta-buttons" style={{
//             display: "flex",
//             gap: "20px",
//             justifyContent: "center",
//             flexWrap: "wrap",
//           }}>
//             <a
//               href="/contact"
//               className="cta-button"
//               style={{
//                 backgroundColor: "#447793",
//                 color: "white",
//                 padding: "15px 40px",
//                 borderRadius: "30px",
//                 fontWeight: "700",
//                 textDecoration: "none",
//                 fontSize: "1.1rem",
//                 transition: "all 0.3s ease",
//                 border: "none",
//                 cursor: "pointer",
//                 display: "inline-block",
//               }}
//               onMouseEnter={(e) => {
//                 e.target.style.backgroundColor = "#2D5A74";
//                 e.target.style.transform = "translateY(-2px)";
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.backgroundColor = "#447793";
//                 e.target.style.transform = "none";
//               }}
//             >
//               📞 Call for Free Consultation
//             </a>
//             <a
//               href="/quote"
//               className="cta-button"
//               style={{
//                 backgroundColor: "transparent",
//                 color: "white",
//                 padding: "15px 40px",
//                 borderRadius: "30px",
//                 fontWeight: "700",
//                 textDecoration: "none",
//                 fontSize: "1.1rem",
//                 border: "2px solid #447793",
//                 transition: "all 0.3s ease",
//                 display: "inline-block",
//               }}
//               onMouseEnter={(e) => {
//                 e.target.style.backgroundColor = "#447793";
//                 e.target.style.color = "white";
//                 e.target.style.transform = "translateY(-2px)";
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.backgroundColor = "transparent";
//                 e.target.style.color = "white";
//                 e.target.style.transform = "none";
//               }}
//             >
//               💰 Get Solar Quote Nagpur
//             </a>
//           </div>
//         </section>
//       </main>

//       {/* Chatbot Component - Blue Theme */}
//       <div style={{
//         position: "fixed",
//         bottom: "20px",
//         right: "20px",
//         zIndex: "9999",
//         fontFamily: "Cambria, serif"
//       }}>
//         {/* Chat Toggle Button */}
//         <button 
//           className="chat-toggle-btn"
//           style={{
//             position: "fixed",
//             bottom: "20px",
//             right: "20px",
//             width: "60px",
//             height: "60px",
//             borderRadius: "50%",
//             background: "linear-gradient(135deg, #447793, #2D5A74)",
//             color: "white",
//             border: "none",
//             fontSize: "24px",
//             cursor: "pointer",
//             boxShadow: "0 8px 30px rgba(68, 119, 147, 0.3)",
//             transition: "all 0.3s ease",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: "10000",
//             padding: "0",
//             animation: chatbotHover ? 'pulse 0.5s infinite' : 'pulse 2s infinite'
//           }}
//           onClick={() => setIsChatOpen(!isChatOpen)}
//           onMouseEnter={() => setChatbotHover(true)}
//           onMouseLeave={() => setChatbotHover(false)}
//         >
//           💬
//         </button>

//         {/* Chat Window */}
//         <div className="chat-window" style={{
//           position: "fixed",
//           bottom: "90px",
//           right: "20px",
//           width: "380px",
//           height: "550px",
//           background: "white",
//           borderRadius: "16px",
//           boxShadow: "0 10px 40px rgba(6, 18, 33, 0.15)",
//           display: "flex",
//           flexDirection: "column",
//           overflow: "hidden",
//           zIndex: "9999",
//           transition: "all 0.3s ease",
//           opacity: isChatOpen ? "1" : "0",
//           visibility: isChatOpen ? "visible" : "hidden",
//           transform: isChatOpen ? "translateY(0)" : "translateY(20px)",
//           border: "1px solid #DDE8ED"
//         }}>
//           {/* Chat Header */}
//           <div style={{
//             background: "linear-gradient(135deg, #447793, #2D5A74)",
//             color: "white",
//             padding: "16px",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             borderBottom: "1px solid rgba(255, 255, 255, 0.1)"
//           }}>
//             <div style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "12px"
//             }}>
//               <div style={{
//                 background: "rgba(255, 255, 255, 0.2)",
//                 padding: "10px",
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 width: "40px",
//                 height: "40px",
//                 fontSize: "18px"
//               }}>
//                 📖
//               </div>
//               <div>
//                 <h3 style={{
//                   margin: "0",
//                   fontSize: "16px",
//                   fontWeight: "600",
//                   lineHeight: "1.2",
//                   color: "white"
//                 }}>
//                   Solar Blog Assistant
//                 </h3>
//                 <p style={{
//                   margin: "0",
//                   fontSize: "12px",
//                   opacity: "0.9",
//                   lineHeight: "1.2",
//                   color: "#DDE8ED"
//                 }}>
//                   Expert Solar Guidance
//                 </p>
//               </div>
//             </div>
//             <button 
//               style={{
//                 background: "none",
//                 border: "none",
//                 color: "white",
//                 cursor: "pointer",
//                 fontSize: "18px",
//                 padding: "5px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 transition: "opacity 0.2s"
//               }}
//               onClick={() => setIsChatOpen(false)}
//             >
//               ✕
//             </button>
//           </div>

//           {/* Quick Replies */}
//           {quickReplies.length > 0 && (
//             <div className="quick-replies" style={{
//               padding: "12px",
//               display: "flex",
//               flexWrap: "wrap",
//               gap: "8px",
//               background: "#DDE8ED",
//               borderBottom: "1px solid #DDE8ED"
//             }}>
//               {quickReplies.map((option, index) => (
//                 <button
//                   key={index}
//                   className="reply-btn"
//                   style={{
//                     background: "white",
//                     border: "1px solid #447793",
//                     color: "#123249",
//                     padding: "8px 16px",
//                     borderRadius: "20px",
//                     fontSize: "13px",
//                     cursor: "pointer",
//                     transition: "all 0.2s ease",
//                     whiteSpace: "nowrap",
//                     fontWeight: "500",
//                     fontFamily: "Cambria, serif"
//                   }}
//                   onClick={() => handleQuickReply(option)}
//                   onMouseEnter={(e) => {
//                     e.target.style.background = '#447793';
//                     e.target.style.color = 'white';
//                     e.target.style.transform = 'translateY(-1px)';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.background = 'white';
//                     e.target.style.color = '#123249';
//                     e.target.style.transform = 'none';
//                   }}
//                 >
//                   {option}
//                 </button>
//               ))}
//             </div>
//           )}

//           {/* Chat Messages */}
//           <div className="chat-messages" style={{
//             flex: "1",
//             padding: "16px",
//             background: "#DDE8ED",
//             overflowY: "auto",
//             display: "flex",
//             flexDirection: "column",
//             gap: "12px"
//           }}>
//             {chatMessages.map((msg) => (
//               <div 
//                 key={msg.id} 
//                 className="message"
//                 style={{
//                   maxWidth: "80%",
//                   padding: "12px 16px",
//                   borderRadius: "18px",
//                   fontSize: "14px",
//                   lineHeight: "1.5",
//                   whiteSpace: "pre-line",
//                   wordWrap: "break-word",
//                   position: "relative",
//                   animation: "fadeIn 0.3s ease",
//                   ...(msg.sender === 'bot' ? {
//                     background: "white",
//                     alignSelf: "flex-start",
//                     borderBottomLeftRadius: "4px",
//                     boxShadow: "0 2px 8px rgba(6, 18, 33, 0.08)",
//                     color: "#123249",
//                     border: "1px solid #DDE8ED"
//                   } : {
//                     background: "linear-gradient(135deg, #447793, #2D5A74)",
//                     color: "white",
//                     alignSelf: "flex-end",
//                     borderBottomRightRadius: "4px"
//                   })
//                 }}
//               >
//                 {msg.text}
//                 <span style={{
//                   fontSize: "11px",
//                   marginTop: "6px",
//                   display: "block",
//                   opacity: "0.7"
//                 }}>
//                   {msg.time}
//                 </span>
//               </div>
//             ))}
//           </div>

//           {/* Chat Input */}
//           <div style={{
//             padding: "16px",
//             borderTop: "1px solid #DDE8ED",
//             background: "white"
//           }}>
//             <div style={{
//               display: "flex",
//               gap: "10px",
//               marginBottom: "8px"
//             }}>
//               <input
//                 type="text"
//                 value={chatInput}
//                 onChange={(e) => setChatInput(e.target.value)}
//                 onKeyPress={handleKeyPress}
//                 placeholder="Ask about solar, subsidies, costs..."
//                 className="chat-input"
//                 style={{
//                   flex: "1",
//                   padding: "12px 16px",
//                   border: "1px solid #DDE8ED",
//                   borderRadius: "25px",
//                   outline: "none",
//                   fontSize: "14px",
//                   fontFamily: "Cambria, serif",
//                   transition: "border-color 0.2s",
//                   color: "#123249"
//                 }}
//                 onFocus={(e) => e.target.style.borderColor = "#447793"}
//                 onBlur={(e) => e.target.style.borderColor = "#DDE8ED"}
//               />
//               <button 
//                 className="send-btn"
//                 style={{
//                   background: "linear-gradient(135deg, #447793, #2D5A74)",
//                   color: "white",
//                   border: "none",
//                   width: "45px",
//                   height: "45px",
//                   borderRadius: "50%",
//                   cursor: "pointer",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: "16px",
//                   transition: "all 0.2s ease",
//                   padding: "0"
//                 }}
//                 onClick={handleChatSend}
//                 onMouseEnter={(e) => {
//                   e.target.style.background = "linear-gradient(135deg, #2D5A74, #123249)";
//                   e.target.style.transform = "scale(1.05)";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.background = "linear-gradient(135deg, #447793, #2D5A74)";
//                   e.target.style.transform = "none";
//                 }}
//               >
//                 📤
//               </button>
//             </div>
//             <p style={{
//               textAlign: "center",
//               fontSize: "11px",
//               color: "#2D5A74",
//               margin: "0"
//             }}>
//               10+ Years Experience • 5000+ Happy Customers
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Blog;
































import React, { useState, useEffect } from "react";

const Blog = () => {
  const [hoveredImage, setHoveredImage] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState('');
  const [leadCaptured, setLeadCaptured] = useState(false);
  const [awaitingLeadInfo, setAwaitingLeadInfo] = useState(false);
  const [leadStep, setLeadStep] = useState(0);
  const [userData, setUserData] = useState({ name: '', phone: '', city: '' });
  const [messageCount, setMessageCount] = useState(0);
  const [quickReplies, setQuickReplies] = useState([]);
  const [chatbotHover, setChatbotHover] = useState(false);

  useEffect(() => {
    if (isChatOpen && chatMessages.length === 0) {
      initChat();
    }
  }, [isChatOpen]);

  const seoData = {
    title: "Solar Panel Installation Blog Nagpur | Solar Energy Guides & Tips",
    metaDescription: "Expert solar panel installation guides, cost analysis in Nagpur, Maharashtra solar subsidy information, and renewable energy solutions for residential & commercial properties across all Nagpur localities including Civil Lines, Dharampeth, Wardha Road, MIHAN, and more.",
    primaryKeyword: "Solar Panel Installation in Nagpur",
    secondaryKeywords: [
      "solar company Nagpur",
      "rooftop solar Nagpur",
      "solar panel price Nagpur",
      "Maharashtra solar subsidy",
      "best solar company Nagpur",
    ],
  };

  // Nagpur Areas/Localities Data - Complete list
  const nagpurAreas = {
    centralOldCity: [
      "Mahal", "Sitabuldi", "Itwari", "Gandhibagh", "Mominpura", 
      "Maskasath", "Ganesh Peth", "Lakadganj", "Gaddi Godam", 
      "Pachpaoli", "Indora", "Bezanbagh", "Bajeria"
    ],
    poshAreas: [
      "Dharampeth", "Ramdaspeth", "Civil Lines", "Bajaj Nagar", 
      "Dhantoli", "Shivaji Nagar", "Shankar Nagar", "Hanuman Nagar", 
      "Gandhinagar", "Byramji Town", "Chaoni", "Ravi Nagar", 
      "Gokulpeth", "Giripeth", "Congress Nagar"
    ],
    developingSuburban: [
      "Trimurti Nagar", "Pratap Nagar", "Manish Nagar", "Narendra Nagar", 
      "Friends Colony", "Jaripatka", "Mankapur", "Seminary Hills", 
      "Vayusena Nagar", "Police Line Takli", "Jaitala", "Waddhamna", 
      "Kalmeshwar", "Wadi"
    ],
    southNewDevelopment: [
      "Besa", "Beltarodi", "Somalwada", "Manewada", "Wathoda", 
      "Nandanvan", "Ayodhya Nagar", "Rameshwari", "Omkar Nagar", 
      "Chatrapati Nagar", "Sneha Nagar", "Reshimbagh", "Swawlambi Nagar", 
      "Khamla", "Dighori"
    ],
    peripheralIndustrial: [
      "MIHAN", "Hingna Road", "Butibori", "Koradi Road", "Kamptee Road", 
      "Pardi", "Kalamna", "Pipla", "Jamtha", "Khapri", "Gorewada"
    ]
  };

  // Flatten all areas for easy use
  const allNagpurAreas = [
    ...nagpurAreas.centralOldCity,
    ...nagpurAreas.poshAreas,
    ...nagpurAreas.developingSuburban,
    ...nagpurAreas.southNewDevelopment,
    ...nagpurAreas.peripheralIndustrial
  ];

  // SEO-Optimized Description Options
  const seoDescriptions = {
    comprehensive: "Explore the best properties in Nagpur, covering all key localities including the premium Civil Lines, Dharampeth, Ramdaspeth, and Shankar Nagar. Whether you are looking for real estate in the fast-developing MIHAN, Wardha Road, Besa, or Manish Nagar, or established, traditional areas like Mahal, Itwari, and Sitabuldi, our listings offer options in Narendra Nagar, Trimurti Nagar, Pratap Nagar, and Manewada. Find your dream home in central or suburban Nagpur today.",
    posh: "Find luxury homes in the top residential areas of Nagpur. Explore premium apartments and bungalows in Civil Lines, Shankar Nagar, Dharampeth, and Ramdaspeth. We have the best, most curated listings in Manish Nagar, Narendra Nagar, Shivaji Nagar, and Bajaj Nagar. Experience high-end living in Trimurti Nagar, Vayusena Nagar, and Seminary Hills with proximity to top schools and cafes. Explore the best of Nagpur living.",
    investment: "Invest in Nagpur's booming real estate market, focusing on high-growth corridors like Wardha Road, MIHAN, and Besa-Pipla Road. Discover budget-friendly flats and plots in Hingna Road, Koradi Road, Kalmeshwar, and Mankapur. We offer prime property options in Manewada, Kalamna, Wathoda, and Pardi. Tap into the future of the Orange City with our expert listings in Jaripatka, Friends Colony, and Jaitala."
  };

  const blogContent = [
    {
      id: 1,
      title: "How Solar Panels Work: A Beginner's Guide for Nagpur Homeowners",
      category: "Educational Guides",
      date: "Dec 15, 2025",
      content: `Solar panels convert sunlight into electricity through photovoltaic cells. These cells are made of semiconductor materials, usually silicon, that absorb photons from sunlight and release electrons, generating an electric current. The process involves several key components: solar panels, inverters, and sometimes battery storage systems. This clean, renewable energy source can significantly reduce your carbon footprint and electricity bills, especially for solar panel installation in Nagpur where sunlight is abundant throughout the year. Understanding how solar panels work is the first step towards adopting solar energy solutions in your home or business across Nagpur localities like ${nagpurAreas.poshAreas.slice(0, 5).join(', ')} and beyond.`,
      detailedContent: `For residents considering solar panel installation in Nagpur, it's important to know that Nagpur receives approximately 300 sunny days annually, making it ideal for solar energy generation. The photovoltaic cells in solar panels create direct current (DC) electricity, which is then converted to alternating current (AC) by inverters for home use. Modern solar systems in Nagpur typically include monitoring systems that allow homeowners to track energy production in real-time. Whether you're looking at residential solar system Nagpur or commercial solar installation Nagpur, the basic principles remain the same. The efficiency of solar panels has improved significantly, with modern panels converting 20-22% of sunlight into electricity, compared to 15% just a decade ago. For Nagpur homeowners in areas like ${nagpurAreas.developingSuburban.slice(0, 6).join(', ')}, this means smaller roof space requirements and faster return on investment.`,
      image: "https://images.unsplash.com/photo-1497440001374-f26997328c1b?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      readTime: "5 min read",
      tags: ["Solar Basics", "Technology", "Guide", "Nagpur Solar", "Home Installation"],
      localKeywords: ["solar panel installation Nagpur", "Nagpur solar company", "home solar Nagpur"],
      slug: "how-solar-panels-work-nagpur-guide",
    },
    {
      id: 2,
      title: "Solar Panel Investment ROI in Nagpur 2026: Cost vs Savings Analysis",
      category: "Cost and Savings Analysis",
      date: "Dec 10, 2025",
      content: `With government incentives and falling installation costs, solar panels offer compelling ROI for Nagpur residents across all localities from ${nagpurAreas.poshAreas.slice(0, 3).join(', ')} to ${nagpurAreas.developingSuburban.slice(0, 2).join(', ')}. Average payback periods have reduced from 8-10 years to 5-7 years in Maharashtra. Key factors affecting ROI include: your location's sunlight exposure, local electricity rates, available tax credits, and system size. We analyze current market trends showing that residential solar installations continue to offer excellent long-term savings, especially with the Maharashtra solar subsidy program making solar panel installation in Nagpur more affordable than ever.`,
      detailedContent: `For a typical 3kW residential solar system in Nagpur, the installation cost ranges between ₹1.5-2 lakhs after subsidies. This system can generate approximately 12-15 units per day, translating to monthly savings of ₹2,500-3,500 on electricity bills. The Maharashtra government's solar subsidy covers 20-40% of installation costs for residential properties, significantly improving ROI. Commercial solar installation Nagpur offers even better returns due to higher consumption and additional tax benefits. When considering solar panel price in Nagpur, factor in: 1) System size and quality, 2) Installation complexity, 3) Government subsidies available, 4) Financing options from local banks, 5) Maintenance costs (typically 0.5-1% annually). Many Nagpur businesses in industrial areas like ${nagpurAreas.peripheralIndustrial.slice(0, 4).join(', ')} are switching to solar to combat rising electricity costs from MSEDCL, with rooftop solar Nagpur installations becoming common in industrial areas like Butibori and Hingna.`,
      image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      readTime: "7 min read",
      tags: ["Cost Analysis", "Savings", "Investment", "Nagpur ROI", "Solar Subsidy"],
      localKeywords: ["solar panel price Nagpur", "solar investment Nagpur", "ROI solar Nagpur"],
      slug: "solar-panel-investment-roi-nagpur-2026",
    },
    {
      id: 3,
      title: "Case Study: 500kW Solar-Powered Manufacturing Plant in Nagpur's Industrial Belt",
      category: "Customer Stories and Case Studies",
      date: "Dec 5, 2025",
      content: `ABC Manufacturing in Hingna, Nagpur's prime industrial locality, reduced their energy costs by 68% after installing our 500kW commercial solar system. The plant now generates 85% of its daytime energy needs through solar power, with an annual saving of ₹42 lakhs. The system included 1,500 solar panels and battery storage for night operations. This transition prevented 850 tons of CO2 emissions annually, showcasing how commercial solar installation Nagpur can transform business operations in industrial areas like ${nagpurAreas.peripheralIndustrial.slice(0, 5).join(', ')}.`,
      detailedContent: `This Nagpur-based manufacturing unit located in the Hingna industrial area faced escalating electricity costs of ₹8-10 lakhs monthly. After installing a 500kW on-grid solar system with net metering, their electricity bills reduced to ₹2.5-3 lakhs monthly. The system covers 3 acres of rooftop space and uses high-efficiency bifacial panels that capture light from both sides. Key features of this commercial solar installation Nagpur project: 1) 500kW capacity with 1500 solar panels, 2) 100kW battery backup for critical operations, 3) Smart monitoring system, 4) Remote troubleshooting capability, 5) 25-year performance warranty. The project qualified for both state and central government subsidies, reducing the payback period to 4.5 years. This case demonstrates why Nagpur industries in Butibori, Hingna Road, Pardi, Kalamna, and Jamtha are rapidly adopting solar solutions, with the MIDC offering additional incentives for green energy adoption.`,
      image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      readTime: "8 min read",
      tags: ["Case Study", "Commercial", "Success Story", "Nagpur Industry", "Manufacturing"],
      localKeywords: ["commercial solar Nagpur", "industrial solar Nagpur", "Nagpur manufacturing solar"],
      slug: "case-study-solar-manufacturing-plant-nagpur",
    },
    {
      id: 4,
      title: "Debunking 7 Common Solar Energy Myths for Nagpur Homeowners",
      category: "Myth Busting",
      date: "Nov 28, 2025",
      content: `Myth 1: Solar panels don't work on cloudy days - FALSE. Modern panels work at 10-25% efficiency even on cloudy days. Myth 2: Solar panels damage your roof - FALSE. Proper installation protects your roof. Myth 3: Maintenance is expensive - FALSE. Solar panels require minimal maintenance. Myth 4: They're too expensive - With subsidies in Maharashtra, prices have dropped 70% in 5 years, making solar panel installation in Nagpur highly affordable for residents of ${nagpurAreas.centralOldCity.slice(0, 5).join(', ')} and beyond.`,
      detailedContent: `As a leading solar company in Nagpur, we frequently encounter misconceptions about solar energy. Let's address the most common myths: 1) 'Nagpur doesn't get enough sun' - FALSE: Nagpur receives 6-7 peak sun hours daily, ideal for solar. 2) 'Solar doesn't work during monsoon' - FALSE: German-designed panels work efficiently in diffused light. 3) 'Installation takes months' - FALSE: Most residential solar system Nagpur installations complete in 3-7 days. 4) 'High maintenance needed' - FALSE: Quarterly cleaning and annual inspection suffice. 5) 'Frequent breakdowns' - FALSE: Solar panels have 25-year warranties with <0.5% annual degradation. 6) 'Not suitable for old buildings' - FALSE: Structural assessment ensures safety for all buildings in areas like ${nagpurAreas.centralOldCity.slice(0, 6).join(', ')}. 7) 'Complicated subsidy process' - FALSE: We handle all Maharashtra solar subsidy paperwork for our Nagpur customers. Understanding these facts helps Nagpur residents make informed decisions about rooftop solar Nagpur installations across all localities.`,
      image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      readTime: "6 min read",
      tags: ["Myths", "Facts", "Education", "Nagpur Solar", "Homeowner Guide"],
      localKeywords: ["solar myths Nagpur", "solar facts Maharashtra", "Nagpur solar truth"],
      slug: "solar-energy-myths-nagpur-homeowners",
    },
    {
      id: 5,
      title: "Step-by-Step Solar Subsidy Process in Maharashtra for Nagpur Residents",
      category: "Step-by-Step Process",
      date: "Nov 20, 2025",
      content: `Complete guide to availing solar subsidy in Maharashtra for Nagpur residents from ${nagpurAreas.poshAreas.slice(0, 3).join(', ')} to ${nagpurAreas.southNewDevelopment.slice(0, 3).join(', ')}. Learn about MSEDCL portal registration, document requirements, inspection process, and subsidy disbursement timeline. Maharashtra offers 20-40% subsidy for residential solar installations through the state solar policy.`,
      detailedContent: `The solar subsidy process in Maharashtra involves: 1) Register on MSEDCL portal, 2) Get technical feasibility approval, 3) Install system from empanelled vendor (like us), 4) Submit commissioning report, 5) Receive subsidy in 30-45 days. For Nagpur residents, additional municipal corporation incentives may apply. The Maharashtra solar subsidy covers: ₹14,000/kW for first 3kW, ₹7,000/kW for next 3kW. We help Nagpur homeowners in areas like ${nagpurAreas.developingSuburban.slice(0, 5).join(', ')} navigate this process seamlessly. Our team has successfully processed subsidies for clients across all Nagpur localities including ${nagpurAreas.southNewDevelopment.slice(0, 5).join(', ')}.`,
      image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      readTime: "6 min read",
      tags: ["Subsidy Guide", "Maharashtra Solar", "Government Incentives", "Nagpur Process"],
      localKeywords: ["solar subsidy Maharashtra", "Nagpur solar subsidy", "MSEDCL solar process"],
      slug: "solar-subsidy-process-maharashtra-nagpur",
    },
    {
      id: 6,
      title: "On-Grid vs Off-Grid vs Hybrid Solar Systems: Best for Nagpur Homes",
      category: "Educational Guides",
      date: "Nov 15, 2025",
      content: `Choosing between on-grid, off-grid, and hybrid solar systems for your Nagpur home depends on your location within the city. For residents in ${nagpurAreas.poshAreas.slice(0, 3).join(', ')} with reliable power, on-grid works best. Those in developing areas like ${nagpurAreas.developingSuburban.slice(0, 3).join(', ')} might benefit from hybrid systems. Most Nagpur homes benefit from on-grid systems due to reliable MSEDCL connection and net metering benefits.`,
      detailedContent: `For Nagpur residential properties across different localities: 1) On-grid solar system - Best for areas with reliable MSEDCL supply like ${nagpurAreas.poshAreas.slice(0, 5).join(', ')}, allows selling excess power, lowest cost. 2) Off-grid solar system - Essential for areas with frequent power cuts like some ${nagpurAreas.peripheralIndustrial.slice(0, 3).join(', ')}, requires battery investment. 3) Hybrid system - Combines both, automatically switches during outages. Considering Nagpur's power reliability, 80% of our installations are on-grid with net metering. We assess your location, consumption pattern, and backup needs to recommend the optimal system for your Nagpur home, whether in ${nagpurAreas.centralOldCity.slice(0, 4).join(', ')} or ${nagpurAreas.southNewDevelopment.slice(0, 4).join(', ')}.`,
      image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      readTime: "7 min read",
      tags: ["System Types", "On-Grid", "Off-Grid", "Hybrid", "Nagpur Solutions"],
      localKeywords: ["on grid solar system", "off grid solar Nagpur", "hybrid solar Maharashtra"],
      slug: "on-grid-off-grid-hybrid-solar-nagpur",
    },
  ];

  const services = [
    {
      id: 1,
      title: "Residential Solar Installation Nagpur",
      description: `Complete rooftop solar solutions for Nagpur homes across all localities including ${nagpurAreas.poshAreas.slice(0, 4).join(', ')} and ${nagpurAreas.developingSuburban.slice(0, 4).join(', ')} with Maharashtra government subsidy support.`,
      icon: "🏠",
      image: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
      link: "/services/residential-solar-nagpur",
    },
    {
      id: 2,
      title: "Commercial Solar Solutions Nagpur",
      description: `Industrial and commercial solar installation Nagpur for factories in ${nagpurAreas.peripheralIndustrial.slice(0, 5).join(', ')} and offices in ${nagpurAreas.poshAreas.slice(0, 3).join(', ')}. Reduce operational costs with tailored commercial solar systems.`,
      icon: "🏢",
      image: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
      link: "/services/commercial-solar-nagpur",
    },
    {
      id: 3,
      title: "Solar Maintenance & Repair Nagpur",
      description: `Professional solar panel maintenance, cleaning, and repair services across all Nagpur areas including ${nagpurAreas.southNewDevelopment.slice(0, 4).join(', ')} and ${nagpurAreas.centralOldCity.slice(0, 4).join(', ')}.`,
      icon: "🔧",
      image: "https://images.unsplash.com/photo-1624395213043-fa2e123b2656?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
      link: "/services/solar-maintenance-nagpur",
    },
  ];

  const researchStudies = [
    {
      id: 1,
      title: "Solar Adoption Trends in Nagpur 2025",
      description: `Research shows 300% growth in residential solar installations in Nagpur over last 3 years, with highest adoption in ${nagpurAreas.poshAreas.slice(0, 3).join(', ')} and fastest growth in ${nagpurAreas.developingSuburban.slice(0, 3).join(', ')}.`,
      icon: "📈",
      image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
      link: "/research/nagpur-solar-trends",
    },
    {
      id: 2,
      title: "ROI Analysis: Solar vs Conventional Power in Maharashtra",
      description: `Comparative study showing solar systems in Maharashtra offer 18-25% annual ROI compared to 8-10% from traditional investments. Nagpur leads in commercial solar adoption due to industrial growth in ${nagpurAreas.peripheralIndustrial.slice(0, 4).join(', ')}.`,
      icon: "💰",
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
      link: "/research/solar-roi-maharashtra",
    },
    {
      id: 3,
      title: "Impact of Solar on Nagpur's Carbon Footprint",
      description: `Study reveals Nagpur's installed solar capacity has reduced CO2 emissions by 45,000 tons annually, with major contributions from residential areas like ${nagpurAreas.southNewDevelopment.slice(0, 3).join(', ')} and industrial zones like ${nagpurAreas.peripheralIndustrial.slice(0, 3).join(', ')}.`,
      icon: "🌍",
      image: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
      link: "/research/carbon-reduction-nagpur",
    },
  ];

  const popularServices = [
    {
      id: 1,
      title: "Solar Panel Installation in Civil Lines",
      description: `Premium solar installation services for ${nagpurAreas.poshAreas.slice(0, 5).join(', ')} with customized designs for heritage and modern homes.`,
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
      link: "/services/installation-civil-lines",
    },
    {
      id: 2,
      title: "Solar Solutions for Wardha Road",
      description: `Specialized solar installations for ${nagpurAreas.southNewDevelopment.slice(0, 5).join(', ')} along the Wardha Road growth corridor.`,
      image: "https://images.unsplash.com/photo-1542332213-9b5a5a3fad55?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
      link: "/services/solar-wardha-road",
    },
    {
      id: 3,
      title: "Industrial Solar for MIHAN & Butibori",
      description: `Large-scale solar installations for industrial areas including ${nagpurAreas.peripheralIndustrial.slice(0, 5).join(', ')} with custom financing options.`,
      image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
      link: "/services/industrial-solar-mihan",
    },
    {
      id: 4,
      title: "Residential Solar for Manish Nagar",
      description: `Affordable residential solar solutions for ${nagpurAreas.developingSuburban.slice(0, 6).join(', ')} with maximum subsidy benefits.`,
      image: "https://images.unsplash.com/photo-1509316785289-025f5b846b35?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
      link: "/services/residential-solar-manish-nagar",
    },
  ];

  const faqItems = [
    {
      question: "How much does solar panel installation cost in Nagpur's different areas?",
      answer: `For a typical 3kW residential solar system in Nagpur, costs range from ₹1.5-2 lakhs after subsidies. Prices are consistent across all Nagpur localities including ${nagpurAreas.poshAreas.slice(0, 3).join(', ')}, ${nagpurAreas.developingSuburban.slice(0, 3).join(', ')}, and ${nagpurAreas.southNewDevelopment.slice(0, 3).join(', ')}. Commercial installations vary based on capacity and requirements.`,
    },
    {
      question: "What solar subsidy is available in Maharashtra for Nagpur residents?",
      answer: `Maharashtra offers 20-40% subsidy: ₹14,000/kW for first 3kW, ₹7,000/kW for next 3kW for residential installations through MSEDCL portal. This applies to all Nagpur areas from ${nagpurAreas.centralOldCity.slice(0, 3).join(', ')} to ${nagpurAreas.peripheralIndustrial.slice(0, 3).join(', ')}.`,
    },
    {
      question: "How many units does 1kW solar generate in different Nagpur localities?",
      answer: `In Nagpur, 1kW solar system generates 4-5 units daily (120-150 units monthly), regardless of locality. Whether you're in ${nagpurAreas.poshAreas.slice(0, 3).join(', ')} or ${nagpurAreas.developingSuburban.slice(0, 3).join(', ')}, generation remains consistent due to Nagpur's uniform solar exposure.`,
    },
    {
      question: "Do you serve all areas of Nagpur?",
      answer: `Yes! We serve ALL Nagpur localities including Central & Old City (${nagpurAreas.centralOldCity.slice(0, 5).join(', ')}...), Residential & Posh Areas (${nagpurAreas.poshAreas.slice(0, 5).join(', ')}...), Developing Suburban Areas (${nagpurAreas.developingSuburban.slice(0, 5).join(', ')}...), South New Development (${nagpurAreas.southNewDevelopment.slice(0, 5).join(', ')}...), and Peripheral Industrial Areas (${nagpurAreas.peripheralIndustrial.slice(0, 5).join(', ')}...). No matter where you are in Nagpur, we provide service!`,
    },
  ];

  const localKeywords = [
    "Solar Panel Installation in Nagpur",
    "Solar Company in Nagpur",
    "Rooftop Solar Nagpur",
    "Residential Solar System Nagpur",
    "Commercial Solar Installation Nagpur",
    "Solar Panel Price in Nagpur",
    "Solar Subsidy Maharashtra",
    "Best Solar Company Nagpur",
    "On Grid Solar System Nagpur",
    "Off Grid Solar System Nagpur",
  ];

  const categories = [
    "Educational Guides",
    "Cost and Savings Analysis",
    "Customer Stories and Case Studies",
    "Myth Busting",
    "Industry News and Innovations",
    "Step-by-Step Process",
    "Environmental Benefits",
  ];

  // Chatbot functions
  const initChat = () => {
    addChatMessage("Hi 👋 Welcome to Blue Sky Energy Solar Blog! I'm here to help you with solar information for your Nagpur location. Whether you're in Civil Lines, Dharampeth, Wardha Road, or any other Nagpur area, I can provide expert advice. How can I assist you today?", 'bot');
    setTimeout(() => {
      addChatMessage("Choose an option to get started:", 'bot');
      setQuickReplies([
        "📖 Read Blog Articles", 
        "💰 Calculate Savings", 
        "📞 Free Consultation",
        "🏠 Residential Solar",
        "🏢 Commercial Solar",
        "📍 Service in My Area"
      ]);
    }, 800);
  };

  const addChatMessage = (text, sender) => {
    const time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const newMessage = {
      text,
      sender,
      time,
      id: Date.now()
    };
    setChatMessages(prev => [...prev, newMessage]);
    if (sender === 'user') {
      setMessageCount(prev => prev + 1);
    }
  };

  const matchKeywords = (input) => {
    const text = input.toLowerCase();
    
    // Check for Nagpur area mentions
    const mentionedArea = allNagpurAreas.find(area => 
      text.includes(area.toLowerCase())
    );
    
    if (mentionedArea) {
      return `📍 Great! You're asking about ${mentionedArea}. We provide complete solar solutions in ${mentionedArea} and all nearby areas. Our team has extensive experience installing solar systems in ${mentionedArea} and surrounding localities. Would you like specific information about solar options for ${mentionedArea}?`;
    }
    
    if (text.includes('area') || text.includes('locality') || text.includes('location') || text.includes('service area')) {
      return `📍 We serve ALL areas of Nagpur including:
      
• Central & Old City: ${nagpurAreas.centralOldCity.slice(0, 8).join(', ')}...
• Posh Areas: ${nagpurAreas.poshAreas.slice(0, 8).join(', ')}...
• Developing Suburban: ${nagpurAreas.developingSuburban.slice(0, 8).join(', ')}...
• South New Development: ${nagpurAreas.southNewDevelopment.slice(0, 8).join(', ')}...
• Industrial Areas: ${nagpurAreas.peripheralIndustrial.slice(0, 8).join(', ')}...

Tell me your area for specific information!`;
    }
    
    if (text.includes('blog') || text.includes('article') || text.includes('read')) {
      return "📖 Blog Articles\n\nWe have 6+ detailed solar articles covering all Nagpur areas:\n1. How Solar Panels Work - Beginner's Guide\n2. Solar Investment ROI in Nagpur 2026\n3. 500kW Manufacturing Plant Case Study\n4. Debunking 7 Solar Myths\n5. Solar Subsidy Process Guide\n6. On-Grid vs Off-Grid Systems\n\nWhich topic interests you?";
    }
    
    if (text.includes('save') || text.includes('saving') || text.includes('cost') || text.includes('roi')) {
      return "💰 Solar Savings Calculator\n\nFor Nagpur Residents in all areas:\n• 3kW System: Saves ₹2,500-3,500/month\n• 5kW System: Saves ₹4,500-6,000/month\n• ROI: 5-7 years after subsidy\n• 25+ years of free electricity after ROI\n\nCommercial (for areas like MIHAN, Butibori):\n• 40kW: Saves ₹88,000/month\n• 500kW: Saves ₹2.2L/month\n\nWant a personalized savings estimate for your area?";
    }
    
    if (text.includes('residential') || text.includes('home') || text.includes('house')) {
      return `🏠 Residential Solar Nagpur\n\nAvailable in all areas including ${nagpurAreas.poshAreas.slice(0, 5).join(', ')} and ${nagpurAreas.developingSuburban.slice(0, 5).join(', ')}\n\n• Typical Cost: ₹1.5-2 lakhs (3kW after subsidy)\n• Monthly Savings: ₹2,500-3,500\n• Payback: 5-7 years\n• Subsidy: 20-40% from Maharashtra Govt\n• Process: 3-7 days installation\n\nWe've installed 1000+ residential systems across all Nagpur localities!`;
    }
    
    if (text.includes('commercial') || text.includes('business') || text.includes('factory') || text.includes('industrial')) {
      return `🏢 Commercial Solar Nagpur\n\nSpecializing in industrial areas: ${nagpurAreas.peripheralIndustrial.slice(0, 6).join(', ')}\n\n• ROI: 3-5 years\n• Tax Benefits: 40% accelerated depreciation\n• Subsidy: Up to 30% for MSME\n• Common Sizes: 10kW to 500kW+\n• Case Studies Available\n\nPerfect for Nagpur industries in Butibori, Hingna, MIHAN, and more!`;
    }
    
    if (text.includes('subsidy') || text.includes('government') || text.includes('msedcl')) {
      return "🏛️ Maharashtra Solar Subsidy\n\n• Residential: ₹14,000/kW (1-3kW)\n• Residential: ₹7,000/kW (4-10kW)\n• MSME: Up to 30% subsidy\n• Process: MSEDCL portal registration\n• Timeline: 30-45 days disbursement\n• We handle all paperwork for clients across Nagpur!\n\nNeed help with subsidy application for your area?";
    }
    
    if (text.includes('install') || text.includes('process') || text.includes('time')) {
      return "⚙️ Installation Process Across Nagpur\n\n1. Free Site Survey (1-2 days) at your location\n2. Custom Design & Quote (1 day)\n3. Subsidy Application (we handle)\n4. Installation (3-7 days)\n5. Commissioning & Training (1 day)\n6. Subsidy Receipt (30-45 days)\n\nComplete process: 45-60 days from start to subsidy, available in all Nagpur areas!";
    }
    
    if (text.includes('maintenance') || text.includes('repair') || text.includes('clean')) {
      return "🔧 Solar Maintenance Across Nagpur\n\n• Cleaning: Quarterly (monsoon: monthly)\n• Inspection: Annual professional check\n• Inverter Service: Every 5 years\n• Warranty: 25 years panels, 10 years inverter\n• Monitoring: Free app for tracking\n• Emergency Support: 24/7 in all Nagpur areas\n\nWe offer AMC starting at ₹2,000/year for all Nagpur localities!";
    }
    
    if (text.includes('consult') || text.includes('free') || text.includes('quote') || text.includes('meet')) {
      return "📞 Free Consultation Anywhere in Nagpur\n\n• Free Site Assessment at your location\n• Custom Solar Design\n• ROI Calculation\n• Subsidy Assistance\n• Financing Options\n• 5000+ Happy Customers Across All Nagpur Areas!\n\nPerfect time to switch - subsidies available!";
    }
    
    if (text.includes('nagpur') || text.includes('city')) {
      return `📍 Solar in Nagpur - All Areas Covered!\n\n• Ideal Location: 300 sunny days/year\n• Peak Sun Hours: 6-7 daily\n• All Areas Served: 
  • Posh: ${nagpurAreas.poshAreas.slice(0, 5).join(', ')}
  • Central: ${nagpurAreas.centralOldCity.slice(0, 5).join(', ')}
  • Developing: ${nagpurAreas.developingSuburban.slice(0, 5).join(', ')}
  • New Areas: ${nagpurAreas.southNewDevelopment.slice(0, 5).join(', ')}
  • Industrial: ${nagpurAreas.peripheralIndustrial.slice(0, 5).join(', ')}
  
• Experience: 10+ years serving all Nagpur areas!
\nWe're Nagpur's trusted Blue Sky Energy company serving every locality!`;
    }
    
    return `I understand you're interested in solar energy! As Nagpur's leading solar blog serving all areas including ${nagpurAreas.poshAreas.slice(0, 3).join(', ')} and ${nagpurAreas.developingSuburban.slice(0, 3).join(', ')}, I can help with:\n• Blog articles & guides\n• Cost & savings calculations\n• Subsidy information\n• Installation process\n• Residential vs commercial systems\n• Service availability in your specific area\n\nWhat would you like to know more about?`;
  };

  const handleLeadCapture = (input) => {
    if (leadStep === 0) {
      setUserData(prev => ({ ...prev, name: input }));
      setLeadStep(1);
      addChatMessage(`Nice to meet you, ${input}! 😊\n\nCould you please share your phone number so our solar experts can contact you?`, 'bot');
    } else if (leadStep === 1) {
      setUserData(prev => ({ ...prev, phone: input }));
      setLeadStep(2);
      addChatMessage("Great! And which area in Nagpur are you from? (e.g., Civil Lines, Dharampeth, Wardha Road, etc.)", 'bot');
    } else if (leadStep === 2) {
      setUserData(prev => ({ ...prev, city: input }));
      setLeadCaptured(true);
      setAwaitingLeadInfo(false);
      saveLead({ ...userData, city: input });
      addChatMessage(`Perfect! Thank you ${userData.name} from ${input}! ✅\n\nOur solar expert will contact you within 24 hours with:\n1. Free site assessment for ${input}\n2. Customized solar design\n3. ROI calculation\n4. Subsidy guidance\n5. Local area specific recommendations\n\nJoin 5000+ happy solar customers across all Nagpur areas!`, 'bot');
    }
  };

  const saveLead = (data) => {
    const leadId = `blog_lead_${Date.now()}`;
    localStorage.setItem(leadId, JSON.stringify({...data, timestamp: new Date(), source: 'blog_chatbot'}));
    console.log("Blog Page Lead Saved:", data);
  };

  const handleChatSend = () => {
    const text = chatInput.trim();
    if (!text) return;

    addChatMessage(text, 'user');
    setChatInput('');
    setQuickReplies([]);

    setTimeout(() => {
      if (awaitingLeadInfo) {
        handleLeadCapture(text);
      } else {
        const response = matchKeywords(text);
        addChatMessage(response, 'bot');

        if (!leadCaptured && messageCount >= 1) {
          setTimeout(() => {
            addChatMessage("Want personalized solar advice for your specific Nagpur area? 📋\n\nCan I get your name to connect you with our local solar experts?", 'bot');
            setAwaitingLeadInfo(true);
          }, 1500);
        }
      }
    }, 600);
  };

  const handleQuickReply = (option) => {
    setChatInput(option);
    setTimeout(() => {
      handleChatSend();
    }, 100);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleChatSend();
    }
  };

  return (
    <div style={{
      fontFamily: "Cambria, serif",
      backgroundColor: "#ffffff",
      minHeight: "100vh",
      color: "#123249",
      overflowX: "hidden"
    }}>
      {/* Responsive CSS - Blue Sky Energy Theme */}
      <style>
        {`
          :root {
            --color-deep-teal: #061221;
            --color-dark-navy: #123249;
            --color-midnight: #2D5A74;
            --color-slate: #447793;
            --color-frost: #DDE8ED;
            --color-white: #ffffff;
            --gradient-primary: linear-gradient(135deg, #447793 0%, #2D5A74 100%);
            --gradient-hover: linear-gradient(135deg, #2D5A74 0%, #123249 100%);
            --gradient-light: linear-gradient(135deg, #DDE8ED 0%, #ffffff 100%);
            --shadow-sm: 0 2px 15px rgba(6, 18, 33, 0.08);
            --shadow-md: 0 4px 20px rgba(6, 18, 33, 0.12);
            --shadow-lg: 0 10px 30px rgba(6, 18, 33, 0.15);
          }

          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
          
          /* Mobile Responsive Styles */
          @media (max-width: 768px) {
            .header-title {
              font-size: 1.8rem !important;
              padding: 0 15px;
            }
            
            .header-subtitle {
              font-size: 1rem !important;
              padding: 0 15px;
            }
            
            .section-title {
              font-size: 1.8rem !important;
            }
            
            .section-subtitle {
              font-size: 1rem !important;
              padding: 0 10px;
            }
            
            .blog-post {
              grid-template-columns: 1fr !important;
              gap: 30px !important;
            }
            
            .blog-image {
              height: 250px !important;
              order: -1;
            }
            
            .blog-title {
              font-size: 1.5rem !important;
            }
            
            .vision-container {
              grid-template-columns: 1fr !important;
              gap: 30px !important;
            }
            
            .vision-content {
              padding-right: 0 !important;
              padding-bottom: 30px;
            }
            
            .vision-points {
              grid-template-columns: 1fr !important;
              gap: 20px !important;
            }
            
            .service-grid,
            .research-grid,
            .popular-grid,
            .categories-grid,
            .keyword-grid {
              grid-template-columns: 1fr !important;
            }
            
            .areas-grid {
              grid-template-columns: 1fr !important;
            }
            
            .area-category {
              padding: 15px !important;
            }
            
            .chat-window {
              width: 90vw !important;
              right: 5vw !important;
              left: 5vw !important;
              bottom: 90px !important;
              height: 500px !important;
              max-height: 70vh !important;
            }
            
            .chat-toggle-btn {
              width: 55px !important;
              height: 55px !important;
              bottom: 20px !important;
              right: 20px !important;
            }
            
            .chat-messages {
              max-height: 300px !important;
            }
            
            .message {
              max-width: 85% !important;
              font-size: 13px !important;
              padding: 10px 14px !important;
            }
            
            .quick-replies {
              flex-wrap: wrap !important;
            }
            
            .reply-btn {
              font-size: 12px !important;
              padding: 6px 12px !important;
              margin: 2px !important;
            }
            
            .cta-buttons {
              flex-direction: column !important;
              gap: 15px !important;
            }
            
            .cta-button {
              width: 100% !important;
              text-align: center;
            }
            
            .main-content {
              padding: 20px 15px !important;
            }
            
            .service-section,
            .research-section,
            .vision-section,
            .popular-services-section,
            .faq-section,
            .areas-section {
              padding: 40px 15px !important;
            }
          }
          
          @media (max-width: 480px) {
            .header-title {
              font-size: 1.5rem !important;
              padding: 0 10px;
            }
            
            .header-subtitle {
              font-size: 0.9rem !important;
              padding: 0 10px;
            }
            
            .section-title {
              font-size: 1.5rem !important;
            }
            
            .blog-title {
              font-size: 1.3rem !important;
            }
            
            .blog-image {
              height: 200px !important;
            }
            
            .category-item {
              padding: 12px !important;
              font-size: 0.9rem !important;
            }
            
            .keyword-tag {
              font-size: 0.8rem !important;
              padding: 6px 12px !important;
            }
            
            .area-badge {
              font-size: 0.8rem !important;
              padding: 4px 8px !important;
            }
            
            .chat-window {
              width: 95vw !important;
              right: 2.5vw !important;
              left: 2.5vw !important;
            }
            
            .chat-input {
              font-size: 13px !important;
              padding: 10px 14px !important;
            }
            
            .send-btn {
              width: 40px !important;
              height: 40px !important;
              font-size: 14px !important;
            }
            
            .tags-container {
              gap: 5px !important;
            }
            
            .tag {
              font-size: 0.7rem !important;
              padding: 4px 8px !important;
            }
          }
          
          @media (min-width: 769px) and (max-width: 1024px) {
            .blog-post {
              gap: 30px !important;
            }
            
            .blog-image {
              height: 300px !important;
            }
            
            .service-grid,
            .research-grid {
              grid-template-columns: repeat(2, 1fr) !important;
            }
            
            .popular-grid {
              grid-template-columns: repeat(2, 1fr) !important;
            }
            
            .categories-grid {
              grid-template-columns: repeat(3, 1fr) !important;
            }
            
            .areas-grid {
              grid-template-columns: repeat(2, 1fr) !important;
            }
            
            .chat-window {
              width: 350px !important;
            }
          }
          
          /* Touch-friendly styles for mobile */
          @media (hover: none) and (pointer: coarse) {
            .service-card:hover,
            .research-card:hover,
            .popular-card:hover,
            .area-category:hover {
              transform: none !important;
            }
            
            .category-item:hover,
            .keyword-tag:hover,
            .area-badge:hover {
              transform: none !important;
            }
            
            .read-more:hover,
            .learn-more:hover,
            .more-button:hover,
            .view-more:hover {
              padding-left: 0 !important;
              gap: 5px !important;
            }
          }
          
          /* Prevent zoom on mobile input */
          @media (max-width: 768px) {
            input, textarea, select {
              font-size: 16px !important;
            }
          }
          
          /* Smooth scrolling */
          html {
            scroll-behavior: smooth;
          }
        `}
      </style>

      {/* Header - Blue Theme */}
      <header style={{
        background: "linear-gradient(rgba(18, 50, 73, 0.95), rgba(45, 90, 116, 0.95))",
        color: "white",
        padding: "80px 20px 50px",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <h1 className="header-title" style={{
          fontSize: "2.8rem",
          fontWeight: "800",
          marginBottom: "20px",
          textShadow: "2px 2px 4px rgba(6, 18, 33, 0.3)",
          maxWidth: "900px",
          margin: "0 auto 20px",
          color: "#ffffff"
        }}>
          Solar Panel Installation Blog Nagpur | Expert Guides & Tips
        </h1>
        <p className="header-subtitle" style={{
          fontSize: "1.2rem",
          maxWidth: "800px",
          margin: "0 auto 30px",
          opacity: "0.95",
          lineHeight: "1.6",
          color: "#DDE8ED"
        }}>
          Discover the latest in solar technology, installation guides, cost analysis for Nagpur, Maharashtra solar subsidy information, and renewable energy solutions for residential & commercial properties across all Nagpur localities including Civil Lines, Dharampeth, Wardha Road, MIHAN, and more.
        </p>
      </header>

      {/* Main Content */}
      <main style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "30px 20px",
        width: "100%",
        boxSizing: "border-box"
      }}>

        {/* SEO Banner - Blue Theme */}
        <div style={{
          backgroundColor: "#DDE8ED",
          borderLeft: "5px solid #447793",
          padding: "25px",
          borderRadius: "10px",
          marginBottom: "40px",
          boxShadow: "0 5px 15px rgba(6, 18, 33, 0.05)",
        }}>
          <h2 style={{
            fontSize: "1.5rem",
            fontWeight: "700",
            color: "#123249",
            marginBottom: "15px",
          }}>
            Looking for Solar Panel Installation in Nagpur?
          </h2>
          <p style={{
            color: "#2D5A74",
            fontSize: "1rem",
            lineHeight: "1.7",
            marginBottom: "15px",
          }}>
            {seoDescriptions.comprehensive}
          </p>
          <p style={{
            color: "#2D5A74",
            fontSize: "1rem",
            lineHeight: "1.7",
            marginBottom: "15px",
          }}>
            {seoDescriptions.posh}
          </p>
          <p style={{
            color: "#2D5A74",
            fontSize: "1rem",
            lineHeight: "1.7",
          }}>
            {seoDescriptions.investment}
          </p>
        </div>

        {/* Nagpur Areas Section - NEW SECTION ADDED */}
        <section className="areas-section" style={{
          backgroundColor: "#ffffff",
          padding: "50px 20px",
          marginBottom: "40px",
          borderRadius: "15px",
          border: "1px solid #DDE8ED",
          boxShadow: "0 10px 30px rgba(6, 18, 33, 0.05)"
        }}>
          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <h2 className="section-title" style={{
              fontSize: "2.5rem",
              fontWeight: "800",
              color: "#123249",
              marginBottom: "15px",
            }}>
              Solar Services Across All Nagpur Localities
            </h2>
            <p className="section-subtitle" style={{
              fontSize: "1.1rem",
              color: "#2D5A74",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}>
              We provide professional solar panel installation across every area of Nagpur. From premium residential localities to industrial zones, our services cover the entire Orange City.
            </p>
          </div>

          <div className="areas-grid" style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "25px",
            marginTop: "30px",
          }}>
            {/* Central & Old City */}
            <div className="area-category" style={{
              backgroundColor: "#DDE8ED",
              padding: "25px",
              borderRadius: "12px",
              transition: "all 0.3s ease",
              border: "1px solid #DDE8ED"
            }}>
              <h3 style={{
                fontSize: "1.3rem",
                fontWeight: "700",
                color: "#123249",
                marginBottom: "20px",
                borderBottom: "2px solid #447793",
                paddingBottom: "10px"
              }}>
                🏛️ Central & Old City
              </h3>
              <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px"
              }}>
                {nagpurAreas.centralOldCity.map((area, index) => (
                  <span key={index} className="area-badge" style={{
                    backgroundColor: "white",
                    color: "#123249",
                    padding: "6px 12px",
                    borderRadius: "20px",
                    fontSize: "0.85rem",
                    fontWeight: "500",
                    border: "1px solid #447793",
                    display: "inline-block"
                  }}>
                    {area}
                  </span>
                ))}
              </div>
            </div>

            {/* Posh Residential Areas */}
            <div className="area-category" style={{
              backgroundColor: "#DDE8ED",
              padding: "25px",
              borderRadius: "12px",
              transition: "all 0.3s ease",
              border: "1px solid #DDE8ED"
            }}>
              <h3 style={{
                fontSize: "1.3rem",
                fontWeight: "700",
                color: "#123249",
                marginBottom: "20px",
                borderBottom: "2px solid #447793",
                paddingBottom: "10px"
              }}>
                🌟 Premium Residential Areas
              </h3>
              <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px"
              }}>
                {nagpurAreas.poshAreas.map((area, index) => (
                  <span key={index} className="area-badge" style={{
                    backgroundColor: "white",
                    color: "#123249",
                    padding: "6px 12px",
                    borderRadius: "20px",
                    fontSize: "0.85rem",
                    fontWeight: "500",
                    border: "1px solid #447793",
                    display: "inline-block"
                  }}>
                    {area}
                  </span>
                ))}
              </div>
            </div>

            {/* Developing & Suburban */}
            <div className="area-category" style={{
              backgroundColor: "#DDE8ED",
              padding: "25px",
              borderRadius: "12px",
              transition: "all 0.3s ease",
              border: "1px solid #DDE8ED"
            }}>
              <h3 style={{
                fontSize: "1.3rem",
                fontWeight: "700",
                color: "#123249",
                marginBottom: "20px",
                borderBottom: "2px solid #447793",
                paddingBottom: "10px"
              }}>
                📈 Developing & Suburban
              </h3>
              <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px"
              }}>
                {nagpurAreas.developingSuburban.map((area, index) => (
                  <span key={index} className="area-badge" style={{
                    backgroundColor: "white",
                    color: "#123249",
                    padding: "6px 12px",
                    borderRadius: "20px",
                    fontSize: "0.85rem",
                    fontWeight: "500",
                    border: "1px solid #447793",
                    display: "inline-block"
                  }}>
                    {area}
                  </span>
                ))}
              </div>
            </div>

            {/* South & New Development */}
            <div className="area-category" style={{
              backgroundColor: "#DDE8ED",
              padding: "25px",
              borderRadius: "12px",
              transition: "all 0.3s ease",
              border: "1px solid #DDE8ED"
            }}>
              <h3 style={{
                fontSize: "1.3rem",
                fontWeight: "700",
                color: "#123249",
                marginBottom: "20px",
                borderBottom: "2px solid #447793",
                paddingBottom: "10px"
              }}>
                🏗️ South & New Development
              </h3>
              <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px"
              }}>
                {nagpurAreas.southNewDevelopment.map((area, index) => (
                  <span key={index} className="area-badge" style={{
                    backgroundColor: "white",
                    color: "#123249",
                    padding: "6px 12px",
                    borderRadius: "20px",
                    fontSize: "0.85rem",
                    fontWeight: "500",
                    border: "1px solid #447793",
                    display: "inline-block"
                  }}>
                    {area}
                  </span>
                ))}
              </div>
            </div>

            {/* Peripheral & Industrial */}
            <div className="area-category" style={{
              backgroundColor: "#DDE8ED",
              padding: "25px",
              borderRadius: "12px",
              transition: "all 0.3s ease",
              border: "1px solid #DDE8ED",
              gridColumn: "span 1"
            }}>
              <h3 style={{
                fontSize: "1.3rem",
                fontWeight: "700",
                color: "#123249",
                marginBottom: "20px",
                borderBottom: "2px solid #447793",
                paddingBottom: "10px"
              }}>
                🏭 Industrial & Peripheral
              </h3>
              <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px"
              }}>
                {nagpurAreas.peripheralIndustrial.map((area, index) => (
                  <span key={index} className="area-badge" style={{
                    backgroundColor: "white",
                    color: "#123249",
                    padding: "6px 12px",
                    borderRadius: "20px",
                    fontSize: "0.85rem",
                    fontWeight: "500",
                    border: "1px solid #447793",
                    display: "inline-block"
                  }}>
                    {area}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Area Stats */}
          <div style={{
            marginTop: "40px",
            textAlign: "center",
            padding: "30px",
            backgroundColor: "#DDE8ED",
            borderRadius: "12px"
          }}>
            <h3 style={{
              fontSize: "1.5rem",
              fontWeight: "700",
              color: "#123249",
              marginBottom: "20px"
            }}>
              We Serve All {allNagpurAreas.length}+ Nagpur Localities
            </h3>
            <p style={{
              color: "#2D5A74",
              fontSize: "1.1rem",
              lineHeight: "1.7",
              marginBottom: "25px"
            }}>
              From {nagpurAreas.poshAreas[0]} to {nagpurAreas.peripheralIndustrial[nagpurAreas.peripheralIndustrial.length-1]}, 
              from {nagpurAreas.centralOldCity[0]} to {nagpurAreas.southNewDevelopment[nagpurAreas.southNewDevelopment.length-1]}, 
              we provide expert solar installation across the entire city. No matter where you are in Nagpur, we'll bring solar energy to your doorstep!
            </p>
            <div style={{
              display: "flex",
              justifyContent: "center",
              gap: "30px",
              flexWrap: "wrap"
            }}>
              <div>
                <span style={{ fontSize: "2rem", fontWeight: "800", color: "#447793" }}>100%</span>
                <p style={{ color: "#123249" }}>Area Coverage</p>
              </div>
              <div>
                <span style={{ fontSize: "2rem", fontWeight: "800", color: "#447793" }}>5000+</span>
                <p style={{ color: "#123249" }}>Happy Customers</p>
              </div>
              <div>
                <span style={{ fontSize: "2rem", fontWeight: "800", color: "#447793" }}>24/7</span>
                <p style={{ color: "#123249" }}>Service All Areas</p>
              </div>
            </div>
          </div>
        </section>

        {/* Local Keywords Section - Blue Theme */}
        <section style={{
          backgroundColor: "#DDE8ED",
          padding: "25px",
          borderRadius: "15px",
          marginTop: "40px",
          marginBottom: "40px",
        }}>
          <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <h2 className="section-title" style={{
              fontSize: "2.5rem",
              fontWeight: "800",
              color: "#123249",
              marginBottom: "15px",
            }}>
              Solar Services in Nagpur
            </h2>
            <p className="section-subtitle" style={{
              fontSize: "1.1rem",
              color: "#2D5A74",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}>
              Searching for these solar solutions in any Nagpur locality? Click for detailed information:
            </p>
          </div>
          <div className="keyword-grid" style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "center",
            marginTop: "20px",
          }}>
            {localKeywords.map((keyword, index) => (
              <a
                key={index}
                href={`/services/${keyword.toLowerCase().replace(/\s+/g, "-")}`}
                className="keyword-tag"
                style={{
                  backgroundColor: "white",
                  color: "#123249",
                  padding: "8px 16px",
                  borderRadius: "20px",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  border: "2px solid #DDE8ED",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  textDecoration: "none",
                  display: "inline-block",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#447793";
                  e.target.style.color = "white";
                  e.target.style.borderColor = "#447793";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "white";
                  e.target.style.color = "#123249";
                  e.target.style.borderColor = "#DDE8ED";
                }}
              >
                {keyword}
              </a>
            ))}
          </div>
        </section>

        {/* Service Section - Blue Theme */}
        <section style={{
          backgroundColor: "#ffffff",
          padding: "60px 20px",
          marginTop: "40px",
        }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: "40px" }}>
              <h2 className="section-title" style={{
                fontSize: "2.5rem",
                fontWeight: "800",
                color: "#123249",
                marginBottom: "15px",
              }}>
                OUR SOLAR SERVICES ACROSS NAGPUR
              </h2>
              <p className="section-subtitle" style={{
                fontSize: "1.1rem",
                color: "#2D5A74",
                maxWidth: "800px",
                margin: "0 auto",
                lineHeight: "1.6",
              }}>
                As a premier solar company in Nagpur, we provide comprehensive solar panel installation services for residential, commercial, and industrial properties across all Nagpur localities including {nagpurAreas.poshAreas.slice(0, 5).join(', ')}, {nagpurAreas.developingSuburban.slice(0, 4).join(', ')}, and {nagpurAreas.peripheralIndustrial.slice(0, 3).join(', ')}.
                Specializing in customized solar solutions with full subsidy support and professional installation.
              </p>
            </div>

            <div className="service-grid" style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "25px",
              marginTop: "30px",
            }}>
              {services.map((service) => (
                <a
                  href={service.link}
                  key={service.id}
                  style={{ textDecoration: "none" }}
                >
                  <div className="service-card" style={{
                    backgroundColor: "white",
                    borderRadius: "15px",
                    overflow: "hidden",
                    boxShadow: "0 10px 30px rgba(6, 18, 33, 0.08)",
                    transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                    position: "relative",
                    cursor: "pointer",
                    border: "1px solid #DDE8ED"
                  }}>
                    <img
                      src={service.image}
                      alt={`${service.title} - Solar Company Nagpur`}
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                        transition: "transform 0.5s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "scale(1)";
                      }}
                    />
                    <div style={{ padding: "20px" }}>
                      <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>{service.icon}</div>
                      <h3 style={{
                        fontSize: "1.4rem",
                        fontWeight: "700",
                        color: "#123249",
                        marginBottom: "10px",
                      }}>{service.title}</h3>
                      <p style={{
                        color: "#2D5A74",
                        fontSize: "0.95rem",
                        lineHeight: "1.6",
                        marginBottom: "20px",
                      }}>
                        {service.description}
                      </p>
                      <div style={{
                        color: "#447793",
                        fontWeight: "600",
                        textDecoration: "none",
                        fontSize: "0.95rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        transition: "all 0.3s ease",
                      }}>
                        Get Free Quote →
                      </div>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* Research Section - Blue Theme */}
        <section style={{
          padding: "60px 20px",
          backgroundColor: "#DDE8ED",
          borderRadius: "15px"
        }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: "40px" }}>
              <h2 className="section-title" style={{
                fontSize: "2.5rem",
                fontWeight: "800",
                color: "#123249",
                marginBottom: "15px",
              }}>
                Solar Research & Case Studies - Nagpur
              </h2>
              <p className="section-subtitle" style={{
                fontSize: "1.1rem",
                color: "#2D5A74",
                maxWidth: "800px",
                margin: "0 auto",
                lineHeight: "1.6",
              }}>
                Data-driven insights on solar adoption, ROI analysis, and environmental impact studies specific to Nagpur and its diverse localities from {nagpurAreas.poshAreas.slice(0, 3).join(', ')} to {nagpurAreas.peripheralIndustrial.slice(0, 3).join(', ')}.
              </p>
            </div>

            <div className="research-grid" style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
              gap: "25px",
              marginTop: "30px",
            }}>
              {researchStudies.map((study) => (
                <a
                  href={study.link}
                  key={study.id}
                  style={{ textDecoration: "none" }}
                >
                  <div className="research-card" style={{
                    backgroundColor: "white",
                    borderRadius: "15px",
                    padding: "25px",
                    transition: "all 0.3s ease",
                    border: "2px solid transparent",
                    boxShadow: "0 10px 30px rgba(6, 18, 33, 0.08)"
                  }}>
                    <div style={{ fontSize: "2.2rem", marginBottom: "20px" }}>{study.icon}</div>
                    <h3 style={{
                      fontSize: "1.3rem",
                      fontWeight: "700",
                      color: "#123249",
                      marginBottom: "15px",
                    }}>{study.title}</h3>
                    <p style={{
                      color: "#2D5A74",
                      fontSize: "0.95rem",
                      lineHeight: "1.6",
                      marginBottom: "25px",
                    }}>
                      {study.description}
                    </p>
                    <div style={{
                      display: "inline-block",
                      backgroundColor: "#447793",
                      color: "white",
                      padding: "10px 25px",
                      borderRadius: "25px",
                      fontWeight: "600",
                      textDecoration: "none",
                      fontSize: "0.9rem",
                      transition: "all 0.3s ease",
                    }}>
                      READ STUDY →
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section - Blue Theme */}
        <section style={{
          backgroundColor: "#ffffff",
          padding: "50px 25px",
          borderRadius: "15px",
          marginTop: "50px",
          marginBottom: "50px",
          border: "1px solid #DDE8ED"
        }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: "40px" }}>
              <h2 className="section-title" style={{
                fontSize: "2.5rem",
                fontWeight: "800",
                color: "#123249",
                marginBottom: "15px",
              }}>
                Frequently Asked Questions - Solar Nagpur
              </h2>
              <p className="section-subtitle" style={{
                fontSize: "1.1rem",
                color: "#2D5A74",
                maxWidth: "800px",
                margin: "0 auto",
                lineHeight: "1.6",
              }}>
                Common questions about solar panel installation, costs, subsidies, and maintenance in all Nagpur localities including {nagpurAreas.centralOldCity.slice(0, 4).join(', ')}, {nagpurAreas.southNewDevelopment.slice(0, 4).join(', ')}, and more.
              </p>
            </div>

            <div style={{ marginTop: "30px" }}>
              {faqItems.map((faq, index) => (
                <div key={index} style={{
                  backgroundColor: "#DDE8ED",
                  padding: "25px",
                  borderRadius: "10px",
                  marginBottom: "20px",
                  boxShadow: "0 5px 15px rgba(6, 18, 33, 0.05)",
                  borderLeft: "4px solid #447793",
                }}>
                  <h3 style={{
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    color: "#123249",
                    marginBottom: "15px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}>
                    ❓ {faq.question}
                  </h3>
                  <p style={{
                    color: "#2D5A74",
                    fontSize: "1rem",
                    lineHeight: "1.7",
                    paddingLeft: "30px",
                  }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Vision Section - Blue Theme */}
        <section style={{
          padding: "60px 20px",
          background: "linear-gradient(135deg, #DDE8ED 0%, #ffffff 100%)",
          borderRadius: "15px"
        }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <div className="vision-container" style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "50px",
              alignItems: "center",
            }}>
              <div className="vision-content" style={{ paddingRight: "40px" }}>
                <h2 className="section-title" style={{
                  fontSize: "2.2rem",
                  fontWeight: "800",
                  color: "#123249",
                  marginBottom: "20px",
                }}>
                  Our Vision for Solar Energy in Nagpur
                </h2>
                <h3 style={{
                  fontSize: "1.8rem",
                  fontWeight: "700",
                  color: "#447793",
                  marginBottom: "30px",
                }}>
                  Leading Nagpur's Solar Revolution Across All Localities
                </h3>
                <p style={{
                  color: "#2D5A74",
                  fontSize: "1rem",
                  lineHeight: "1.7",
                  marginBottom: "25px",
                }}>
                  We envision making every Nagpur locality from {nagpurAreas.poshAreas[0]} to {nagpurAreas.peripheralIndustrial[nagpurAreas.peripheralIndustrial.length-1]} a solar-powered community by 2030, with every home and business benefiting from clean, affordable solar energy. As Nagpur's trusted Blue Sky Energy solar company, we're committed to providing top-quality solar panel installation across all Nagpur areas with comprehensive support for Maharashtra solar subsidy applications.
                </p>
                <p style={{
                  color: "#2D5A74",
                  fontSize: "1rem",
                  lineHeight: "1.7",
                  marginBottom: "25px",
                }}>
                  Our mission extends beyond installation - we aim to educate residents of {nagpurAreas.developingSuburban.slice(0, 5).join(', ')} and {nagpurAreas.southNewDevelopment.slice(0, 5).join(', ')} about the benefits of rooftop solar Nagpur systems, help them navigate the solar subsidy process in Maharashtra, and provide ongoing maintenance for optimal system performance.
                </p>
              </div>

              <div className="vision-points" style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "25px",
                marginTop: "0",
              }}>
                <div style={{
                  backgroundColor: "white",
                  padding: "25px",
                  borderRadius: "12px",
                  boxShadow: "0 5px 15px rgba(6, 18, 33, 0.05)",
                  border: "1px solid #DDE8ED"
                }}>
                  <h4 style={{
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    color: "#123249",
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}>
                    🎯 Nagpur Solar Target
                  </h4>
                  <p style={{
                    color: "#2D5A74",
                    fontSize: "0.95rem",
                    lineHeight: "1.6",
                  }}>
                    Install 10,000+ solar systems across all Nagpur localities including {nagpurAreas.poshAreas.slice(0, 3).join(', ')}, {nagpurAreas.developingSuburban.slice(0, 3).join(', ')}, and {nagpurAreas.peripheralIndustrial.slice(0, 2).join(', ')} by 2027, reducing carbon emissions by 50,000 tons annually and helping residents save ₹50+ crores on electricity bills.
                  </p>
                </div>
                <div style={{
                  backgroundColor: "white",
                  padding: "25px",
                  borderRadius: "12px",
                  boxShadow: "0 5px 15px rgba(6, 18, 33, 0.05)",
                  border: "1px solid #DDE8ED"
                }}>
                  <h4 style={{
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    color: "#123249",
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}>
                    💡 Area-Specific Solutions
                  </h4>
                  <p style={{
                    color: "#2D5A74",
                    fontSize: "0.95rem",
                    lineHeight: "1.6",
                  }}>
                    Implementing customized solar solutions for each Nagpur locality - heritage-friendly installations for {nagpurAreas.centralOldCity.slice(0, 4).join(', ')}, premium systems for {nagpurAreas.poshAreas.slice(0, 4).join(', ')}, and large-scale industrial setups for {nagpurAreas.peripheralIndustrial.slice(0, 4).join(', ')}.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Popular Services Section - Blue Theme */}
        <section style={{
          padding: "60px 20px",
          backgroundColor: "#ffffff",
        }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: "40px" }}>
              <h2 className="section-title" style={{
                fontSize: "2.5rem",
                fontWeight: "800",
                color: "#123249",
                marginBottom: "15px",
              }}>
                Most Popular Solar Services by Nagpur Area
              </h2>
              <p className="section-subtitle" style={{
                fontSize: "1.1rem",
                color: "#2D5A74",
                maxWidth: "800px",
                margin: "0 auto",
                lineHeight: "1.6",
              }}>
                Services most requested by our customers in different Nagpur localities - tailored solutions for every area.
              </p>
            </div>

            <div className="popular-grid" style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "25px",
              marginTop: "30px",
            }}>
              {popularServices.map((service) => (
                <a
                  href={service.link}
                  key={service.id}
                  style={{ textDecoration: "none" }}
                >
                  <div className="popular-card" style={{
                    backgroundColor: "#DDE8ED",
                    borderRadius: "12px",
                    padding: "25px",
                    textAlign: "center",
                    transition: "all 0.3s ease",
                    border: "2px solid transparent",
                    cursor: "pointer",
                  }}>
                    <h3 style={{
                      fontSize: "1.3rem",
                      fontWeight: "700",
                      color: "#123249",
                      marginBottom: "10px",
                    }}>{service.title}</h3>
                    <p style={{
                      color: "#2D5A74",
                      fontSize: "0.9rem",
                      marginBottom: "20px",
                      lineHeight: "1.6",
                    }}>
                      {service.description}
                    </p>
                    <div style={{
                      display: "inline-block",
                      color: "#447793",
                      fontWeight: "600",
                      textDecoration: "none",
                      fontSize: "0.9rem",
                    }}>
                      Get Service Details →
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* Blog Categories Section - Blue Theme */}
        <section style={{
          backgroundColor: "#DDE8ED",
          padding: "25px",
          borderRadius: "15px",
          marginBottom: "40px",
          boxShadow: "0 5px 15px rgba(6, 18, 33, 0.05)",
        }}>
          <h2 style={{
            fontSize: "1.8rem",
            color: "#123249",
            marginBottom: "25px",
            textAlign: "center",
            fontWeight: "700",
          }}>
            Browse Solar Topics for All Nagpur Areas
          </h2>
          <div className="categories-grid" style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
            gap: "15px",
            textAlign: "center",
          }}>
            {categories.map((category, index) => (
              <div
                key={index}
                className="category-item"
                style={{
                  padding: "15px",
                  backgroundColor: "white",
                  borderRadius: "10px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  border: "2px solid #DDE8ED",
                  fontWeight: "600",
                  color: "#123249",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#447793";
                  e.target.style.color = "white";
                  e.target.style.borderColor = "#447793";
                  e.target.style.transform = "translateY(-3px)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "white";
                  e.target.style.color = "#123249";
                  e.target.style.borderColor = "#DDE8ED";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                {category}
              </div>
            ))}
          </div>
        </section>

        {/* Blog Posts Section - Blue Theme */}
        <section style={{
          display: "flex",
          flexDirection: "column",
          gap: "50px",
          marginTop: "60px",
        }}>
          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <h2 className="section-title" style={{
              fontSize: "2.5rem",
              fontWeight: "800",
              color: "#123249",
              marginBottom: "15px",
            }}>
              Latest Solar Insights & Guides for Nagpur's Localities
            </h2>
            <p className="section-subtitle" style={{
              fontSize: "1.1rem",
              color: "#2D5A74",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}>
              In-depth articles, installation guides, cost analysis, and solar subsidy information specifically for all Nagpur localities including {nagpurAreas.poshAreas.slice(0, 4).join(', ')}, {nagpurAreas.developingSuburban.slice(0, 4).join(', ')}, {nagpurAreas.centralOldCity.slice(0, 3).join(', ')}, and more.
            </p>
          </div>

          {blogContent.map((post, index) => (
            <article
              key={post.id}
              className="blog-post"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "40px",
                alignItems: "center",
                paddingBottom: "40px",
                borderBottom: "1px solid #DDE8ED",
              }}
            >
              {index % 2 === 0 ? (
                <>
                  <div>
                    <img
                      src={post.image}
                      alt={`${post.title} - Solar Panel Installation Nagpur`}
                      className="blog-image"
                      style={{
                        width: "100%",
                        height: "350px",
                        borderRadius: "12px",
                        objectFit: "cover",
                        transition: "transform 0.5s ease",
                        cursor: "pointer",
                        boxShadow: "0 10px 25px rgba(6, 18, 33, 0.1)",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.05)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "scale(1)";
                      }}
                    />
                  </div>
                  <div style={{ padding: "20px 0" }}>
                    <span style={{
                      display: "inline-block",
                      backgroundColor: "#DDE8ED",
                      color: "#123249",
                      padding: "6px 15px",
                      borderRadius: "20px",
                      fontSize: "0.85rem",
                      fontWeight: "600",
                      marginBottom: "15px",
                    }}>
                      {post.category}
                    </span>
                    <h3 className="blog-title" style={{
                      fontSize: "1.8rem",
                      fontWeight: "700",
                      color: "#123249",
                      marginBottom: "15px",
                      lineHeight: "1.3",
                    }}>
                      {post.title}
                    </h3>
                    <div style={{
                      color: "#2D5A74",
                      fontSize: "0.9rem",
                      marginBottom: "20px",
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                      flexWrap: "wrap",
                    }}>
                      <span>{post.date}</span>
                      <span>•</span>
                      <span>{post.readTime}</span>
                    </div>
                    <p style={{
                      color: "#2D5A74",
                      fontSize: "1rem",
                      lineHeight: "1.7",
                      marginBottom: "25px",
                    }}>
                      {post.content}
                    </p>
                    <div className="tags-container" style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                      marginTop: "25px",
                    }}>
                      {post.tags.map((tag) => (
                        <span key={tag} style={{
                          backgroundColor: "#DDE8ED",
                          color: "#123249",
                          padding: "6px 12px",
                          borderRadius: "15px",
                          fontSize: "0.8rem",
                          fontWeight: "500",
                        }}>
                          {tag}
                        </span>
                      ))}
                    </div>
                    <p style={{
                      color: "#2D5A74",
                      fontSize: "0.95rem",
                      lineHeight: "1.6",
                      marginTop: "15px",
                    }}>
                      Keywords: {post.localKeywords.join(", ")}
                    </p>
                    <a href={`/blog/${post.slug}`} className="read-more" style={{
                      display: "inline-block",
                      color: "#447793",
                      fontWeight: "600",
                      textDecoration: "none",
                      fontSize: "1rem",
                      marginTop: "20px",
                      padding: "10px 0",
                      transition: "all 0.3s ease",
                    }}>
                      Read Full Article about {post.localKeywords[0]} for Your Nagpur Area →
                    </a>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ padding: "20px 0" }}>
                    <span style={{
                      display: "inline-block",
                      backgroundColor: "#DDE8ED",
                      color: "#123249",
                      padding: "6px 15px",
                      borderRadius: "20px",
                      fontSize: "0.85rem",
                      fontWeight: "600",
                      marginBottom: "15px",
                    }}>
                      {post.category}
                    </span>
                    <h3 className="blog-title" style={{
                      fontSize: "1.8rem",
                      fontWeight: "700",
                      color: "#123249",
                      marginBottom: "15px",
                      lineHeight: "1.3",
                    }}>
                      {post.title}
                    </h3>
                    <div style={{
                      color: "#2D5A74",
                      fontSize: "0.9rem",
                      marginBottom: "20px",
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                      flexWrap: "wrap",
                    }}>
                      <span>{post.date}</span>
                      <span>•</span>
                      <span>{post.readTime}</span>
                    </div>
                    <p style={{
                      color: "#2D5A74",
                      fontSize: "1rem",
                      lineHeight: "1.7",
                      marginBottom: "25px",
                    }}>
                      {post.content}
                    </p>
                    <div className="tags-container" style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                      marginTop: "25px",
                    }}>
                      {post.tags.map((tag) => (
                        <span key={tag} style={{
                          backgroundColor: "#DDE8ED",
                          color: "#123249",
                          padding: "6px 12px",
                          borderRadius: "15px",
                          fontSize: "0.8rem",
                          fontWeight: "500",
                        }}>
                          {tag}
                        </span>
                      ))}
                    </div>
                    <p style={{
                      color: "#2D5A74",
                      fontSize: "0.95rem",
                      lineHeight: "1.6",
                      marginTop: "15px",
                    }}>
                      Keywords: {post.localKeywords.join(", ")}
                    </p>
                    <a href={`/blog/${post.slug}`} className="read-more" style={{
                      display: "inline-block",
                      color: "#447793",
                      fontWeight: "600",
                      textDecoration: "none",
                      fontSize: "1rem",
                      marginTop: "20px",
                      padding: "10px 0",
                      transition: "all 0.3s ease",
                    }}>
                      Read Full Article about {post.localKeywords[0]} for Your Nagpur Area →
                    </a>
                  </div>
                  <div>
                    <img
                      src={post.image}
                      alt={`${post.title} - Solar Company Nagpur`}
                      className="blog-image"
                      style={{
                        width: "100%",
                        height: "350px",
                        borderRadius: "12px",
                        objectFit: "cover",
                        transition: "transform 0.5s ease",
                        cursor: "pointer",
                        boxShadow: "0 10px 25px rgba(6, 18, 33, 0.1)",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.05)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "scale(1)";
                      }}
                    />
                  </div>
                </>
              )}
            </article>
          ))}
        </section>

        {/* Call to Action Section - Blue Theme */}
        <section style={{
          backgroundColor: "#123249",
          color: "white",
          padding: "60px 20px",
          textAlign: "center",
          borderRadius: "15px",
          marginTop: "50px",
          marginBottom: "50px",
        }}>
          <h2 style={{
            fontSize: "2.2rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "#ffffff"
          }}>
            Ready for Solar Panel Installation in Your Nagpur Area?
          </h2>
          <p style={{
            fontSize: "1.2rem",
            maxWidth: "800px",
            margin: "0 auto 40px",
            lineHeight: "1.6",
            color: "#DDE8ED"
          }}>
            Get a free solar consultation for your Nagpur home or business, no matter which locality you're in - {nagpurAreas.poshAreas.slice(0, 3).join(', ')}, {nagpurAreas.developingSuburban.slice(0, 3).join(', ')}, {nagpurAreas.centralOldCity.slice(0, 3).join(', ')}, or {nagpurAreas.peripheralIndustrial.slice(0, 2).join(', ')}. We'll assess your needs, explain Maharashtra solar subsidy options, and provide a customized quote for solar panel installation in your specific Nagpur area.
          </p>
          <div className="cta-buttons" style={{
            display: "flex",
            gap: "20px",
            justifyContent: "center",
            flexWrap: "wrap",
          }}>
            <a
              href="/contact"
              className="cta-button"
              style={{
                backgroundColor: "#447793",
                color: "white",
                padding: "15px 40px",
                borderRadius: "30px",
                fontWeight: "700",
                textDecoration: "none",
                fontSize: "1.1rem",
                transition: "all 0.3s ease",
                border: "none",
                cursor: "pointer",
                display: "inline-block",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#2D5A74";
                e.target.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#447793";
                e.target.style.transform = "none";
              }}
            >
              📞 Call for Free Consultation
            </a>
            <a
              href="/quote"
              className="cta-button"
              style={{
                backgroundColor: "transparent",
                color: "white",
                padding: "15px 40px",
                borderRadius: "30px",
                fontWeight: "700",
                textDecoration: "none",
                fontSize: "1.1rem",
                border: "2px solid #447793",
                transition: "all 0.3s ease",
                display: "inline-block",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#447793";
                e.target.style.color = "white";
                e.target.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "white";
                e.target.style.transform = "none";
              }}
            >
              💰 Get Solar Quote for Your Area
            </a>
          </div>
        </section>
      </main>

      {/* Chatbot Component - Blue Theme */}
      <div style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: "9999",
        fontFamily: "Cambria, serif"
      }}>
        {/* Chat Toggle Button */}
        <button 
          className="chat-toggle-btn"
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #447793, #2D5A74)",
            color: "white",
            border: "none",
            fontSize: "24px",
            cursor: "pointer",
            boxShadow: "0 8px 30px rgba(68, 119, 147, 0.3)",
            transition: "all 0.3s ease",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: "10000",
            padding: "0",
            animation: chatbotHover ? 'pulse 0.5s infinite' : 'pulse 2s infinite'
          }}
          onClick={() => setIsChatOpen(!isChatOpen)}
          onMouseEnter={() => setChatbotHover(true)}
          onMouseLeave={() => setChatbotHover(false)}
        >
          💬
        </button>

        {/* Chat Window */}
        <div className="chat-window" style={{
          position: "fixed",
          bottom: "90px",
          right: "20px",
          width: "380px",
          height: "550px",
          background: "white",
          borderRadius: "16px",
          boxShadow: "0 10px 40px rgba(6, 18, 33, 0.15)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          zIndex: "9999",
          transition: "all 0.3s ease",
          opacity: isChatOpen ? "1" : "0",
          visibility: isChatOpen ? "visible" : "hidden",
          transform: isChatOpen ? "translateY(0)" : "translateY(20px)",
          border: "1px solid #DDE8ED"
        }}>
          {/* Chat Header */}
          <div style={{
            background: "linear-gradient(135deg, #447793, #2D5A74)",
            color: "white",
            padding: "16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid rgba(255, 255, 255, 0.1)"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "12px"
            }}>
              <div style={{
                background: "rgba(255, 255, 255, 0.2)",
                padding: "10px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "40px",
                height: "40px",
                fontSize: "18px"
              }}>
                📖
              </div>
              <div>
                <h3 style={{
                  margin: "0",
                  fontSize: "16px",
                  fontWeight: "600",
                  lineHeight: "1.2",
                  color: "white"
                }}>
                  Solar Blog Assistant
                </h3>
                <p style={{
                  margin: "0",
                  fontSize: "12px",
                  opacity: "0.9",
                  lineHeight: "1.2",
                  color: "#DDE8ED"
                }}>
                  Expert for All Nagpur Areas
                </p>
              </div>
            </div>
            <button 
              style={{
                background: "none",
                border: "none",
                color: "white",
                cursor: "pointer",
                fontSize: "18px",
                padding: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "opacity 0.2s"
              }}
              onClick={() => setIsChatOpen(false)}
            >
              ✕
            </button>
          </div>

          {/* Quick Replies */}
          {quickReplies.length > 0 && (
            <div className="quick-replies" style={{
              padding: "12px",
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              background: "#DDE8ED",
              borderBottom: "1px solid #DDE8ED"
            }}>
              {quickReplies.map((option, index) => (
                <button
                  key={index}
                  className="reply-btn"
                  style={{
                    background: "white",
                    border: "1px solid #447793",
                    color: "#123249",
                    padding: "8px 16px",
                    borderRadius: "20px",
                    fontSize: "13px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    whiteSpace: "nowrap",
                    fontWeight: "500",
                    fontFamily: "Cambria, serif"
                  }}
                  onClick={() => handleQuickReply(option)}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#447793';
                    e.target.style.color = 'white';
                    e.target.style.transform = 'translateY(-1px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'white';
                    e.target.style.color = '#123249';
                    e.target.style.transform = 'none';
                  }}
                >
                  {option}
                </button>
              ))}
            </div>
          )}

          {/* Chat Messages */}
          <div className="chat-messages" style={{
            flex: "1",
            padding: "16px",
            background: "#DDE8ED",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            gap: "12px"
          }}>
            {chatMessages.map((msg) => (
              <div 
                key={msg.id} 
                className="message"
                style={{
                  maxWidth: "80%",
                  padding: "12px 16px",
                  borderRadius: "18px",
                  fontSize: "14px",
                  lineHeight: "1.5",
                  whiteSpace: "pre-line",
                  wordWrap: "break-word",
                  position: "relative",
                  animation: "fadeIn 0.3s ease",
                  ...(msg.sender === 'bot' ? {
                    background: "white",
                    alignSelf: "flex-start",
                    borderBottomLeftRadius: "4px",
                    boxShadow: "0 2px 8px rgba(6, 18, 33, 0.08)",
                    color: "#123249",
                    border: "1px solid #DDE8ED"
                  } : {
                    background: "linear-gradient(135deg, #447793, #2D5A74)",
                    color: "white",
                    alignSelf: "flex-end",
                    borderBottomRightRadius: "4px"
                  })
                }}
              >
                {msg.text}
                <span style={{
                  fontSize: "11px",
                  marginTop: "6px",
                  display: "block",
                  opacity: "0.7"
                }}>
                  {msg.time}
                </span>
              </div>
            ))}
          </div>

          {/* Chat Input */}
          <div style={{
            padding: "16px",
            borderTop: "1px solid #DDE8ED",
            background: "white"
          }}>
            <div style={{
              display: "flex",
              gap: "10px",
              marginBottom: "8px"
            }}>
              <input
                type="text"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Ask about solar in your Nagpur area..."
                className="chat-input"
                style={{
                  flex: "1",
                  padding: "12px 16px",
                  border: "1px solid #DDE8ED",
                  borderRadius: "25px",
                  outline: "none",
                  fontSize: "14px",
                  fontFamily: "Cambria, serif",
                  transition: "border-color 0.2s",
                  color: "#123249"
                }}
                onFocus={(e) => e.target.style.borderColor = "#447793"}
                onBlur={(e) => e.target.style.borderColor = "#DDE8ED"}
              />
              <button 
                className="send-btn"
                style={{
                  background: "linear-gradient(135deg, #447793, #2D5A74)",
                  color: "white",
                  border: "none",
                  width: "45px",
                  height: "45px",
                  borderRadius: "50%",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "16px",
                  transition: "all 0.2s ease",
                  padding: "0"
                }}
                onClick={handleChatSend}
                onMouseEnter={(e) => {
                  e.target.style.background = "linear-gradient(135deg, #2D5A74, #123249)";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "linear-gradient(135deg, #447793, #2D5A74)";
                  e.target.style.transform = "none";
                }}
              >
                📤
              </button>
            </div>
            <p style={{
              textAlign: "center",
              fontSize: "11px",
              color: "#2D5A74",
              margin: "0"
            }}>
              Serving All {allNagpurAreas.length}+ Nagpur Localities • 5000+ Happy Customers
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;